export const BuildModuleRuleDummyRoles = [
  // BILL_GENERATION
  {
    id: { id: "a112e980-18e4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492101,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Generate Bill",
    clazz: "org.thingsboard.rule.engine.transform.TbTransformNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Generates monthly bills using usage and tariff data.",
        details: "Automatically triggers bill creation for monthly cycles.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        defaultConfiguration: {
          billingCycle: "MONTHLY",
          includeTaxes: true,
        },
        uiResources: ["static/rulenode/rulenode-billing-config.js"],
        configDirective: "tbBillGenerationNodeConfig",
      },
    },
  },
  {
    id: { id: "bgen-101-11ef-a60f-836bea56f698" },
    createdTime: 1739165492101,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Monthly Bill Generator",
    clazz: "org.billing.rule.engine.generation.TbMonthlyBillGenerationNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Generates monthly bills using usage and tariff data.",
        details: "Automatically triggers bill creation for monthly cycles.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        defaultConfiguration: {
          billingCycle: "MONTHLY",
          includeTaxes: true,
        },
        uiResources: ["static/rulenode/rulenode-billing-config.js"],
        configDirective: "tbBillGenerationNodeConfig",
      },
    },
  },
  {
    id: { id: "bgen-102-11ef-a60f-836bea56f698" },
    createdTime: 1739165492102,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "On-Demand Bill Generator",
    clazz: "org.billing.rule.engine.generation.TbOnDemandBillGenerationNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Generates bills instantly for selected accounts.",
        details: "Useful for testing or ad-hoc bill generation.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        defaultConfiguration: {
          billingCycle: "MANUAL",
          autoApprove: false,
        },
      },
    },
  },
  {
    id: { id: "bgen-103-11ef-a60f-836bea56f698" },
    createdTime: 1739165492103,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Consumption-Based Bill Generator",
    clazz: "org.billing.rule.engine.generation.TbConsumptionBillNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Generates bill based on real-time consumption data.",
        details: "Supports smart-meter-based billing.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        defaultConfiguration: {
          dataSource: "METER_READING",
          roundingPrecision: 2,
        },
      },
    },
  },

  // BILL_VALIDATION
  {
    id: { id: "a112fa40-18e4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165493101,
    type: "BILL_VALIDATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Validate Bill Amount",
    clazz: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Validates generated bills before finalization.",
        details:
          "Checks usage, meter readings, and tariff rules for consistency.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Valid", "Invalid"],
        defaultConfiguration: {
          allowNegative: false,
          minThreshold: 0,
          maxThreshold: 999999,
        },
        uiResources: ["static/rulenode/rulenode-validation-config.js"],
        configDirective: "tbBillValidationNodeConfig",
      },
    },
  },
  {
    id: { id: "a21ae180-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165493101,
    type: "BILL_VALIDATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Validate Bill Data",
    clazz: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Validates generated bills before finalization.",
        details:
          "Checks usage, meter readings, and tariff rules for consistency.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Valid", "Invalid"],
        defaultConfiguration: {
          allowNegative: false,
          minThreshold: 0,
          maxThreshold: 999999,
        },
        uiResources: ["static/rulenode/rulenode-validation-config.js"],
        configDirective: "tbBillValidationNodeConfig",
      },
    },
  },
  {
    id: { id: "b11c1a90-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165493101,
    type: "BILL_VALIDATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Validate Bill Due Date",
    clazz: "org.thingsboard.rule.engine.filter.TbJsBillValidationNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Validates generated bills before finalization.",
        details:
          "Checks usage, meter readings, and tariff rules for consistency.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Valid", "Invalid"],
        defaultConfiguration: {
          allowNegative: false,
          minThreshold: 0,
          maxThreshold: 999999,
        },
        uiResources: ["static/rulenode/rulenode-validation-config.js"],
        configDirective: "tbBillValidationNodeConfig",
      },
    },
  },
  {
    id: { id: "bval-201-11ef-a60f-836bea56f698" },
    createdTime: 1739165492201,
    type: "BILL_VALIDATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Basic Bill Validator",
    clazz: "org.billing.rule.engine.validation.TbBasicBillValidationNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Validates basic fields of a generated bill.",
        details: "Checks for missing or null fields.",
        relationTypes: ["Valid", "Invalid"],
        defaultConfiguration: {
          checkTax: true,
          checkDueDate: true,
        },
      },
    },
  },
  {
    id: { id: "bval-202-11ef-a60f-836bea56f698" },
    createdTime: 1739165492202,
    type: "BILL_VALIDATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Tariff Consistency Validator",
    clazz: "org.billing.rule.engine.validation.TbTariffCheckNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Ensures the correct tariff plan is applied to the bill.",
        details: "Compares tariff version with current contract.",
        relationTypes: ["Valid", "Invalid"],
        defaultConfiguration: {
          tariffCheck: "LATEST",
        },
      },
    },
  },
  {
    id: { id: "bval-203-11ef-a60f-836bea56f698" },
    createdTime: 1739165492203,
    type: "BILL_VALIDATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Bill Anomaly Detector",
    clazz: "org.billing.rule.engine.validation.TbBillAnomalyDetectionNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Detects abnormal consumption or high bill spikes.",
        details: "Uses threshold-based validation.",
        relationTypes: ["Normal", "Anomaly"],
        defaultConfiguration: {
          deviationThresholdPercent: 25,
        },
      },
    },
  },

  // BILL_ADJUSTMENT
  {
    id: { id: "badj-104-11ef-a60f-836bea56f698" },
    createdTime: 1739165495101,
    type: "BILL_ADJUSTMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Bill Adjustment Processor",
    clazz: "org.billing.rule.engine.adjustment.TbBillAdjustmentNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Handles adjustments like refunds or manual corrections.",
        details: "Supports admin and system-initiated adjustments.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Adjusted", "Rejected"],
        defaultConfiguration: {
          allowManual: true,
          requireApproval: true,
        },
        uiResources: ["static/rulenode/rulenode-adjustment-config.js"],
        configDirective: "tbBillAdjustmentNodeConfig",
      },
    },
  },
  {
    id: { id: "badj-301-11ef-a60f-836bea56f698" },
    createdTime: 1739165492301,
    type: "BILL_ADJUSTMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Auto Adjustment Rule",
    clazz: "org.billing.rule.engine.adjustment.TbAutoAdjustmentNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Automatically adjusts minor billing discrepancies.",
        details: "Adjusts within a defined percentage limit.",
        relationTypes: ["Adjusted", "NoChange"],
        defaultConfiguration: {
          maxPercent: 5,
        },
      },
    },
  },
  {
    id: { id: "badj-302-11ef-a60f-836bea56f698" },
    createdTime: 1739165492302,
    type: "BILL_ADJUSTMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Manual Credit Adjustment",
    clazz: "org.billing.rule.engine.adjustment.TbManualCreditAdjustmentNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Allows admin to apply manual credits.",
        relationTypes: ["Approved", "Rejected"],
        defaultConfiguration: {
          requireApproval: true,
        },
      },
    },
  },

  // BILL_DUE_REMINDER
  {
    id: { id: "bdue-103-11ef-a60f-836bea56f698" },
    createdTime: 1739165494101,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Due Reminder Sender",
    clazz: "org.billing.rule.engine.notification.TbDueReminderNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description:
          "Sends due date reminders to users before the bill due date.",
        details: "Configurable reminder intervals and communication channels.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Sent", "Failed"],
        defaultConfiguration: {
          reminderDaysBefore: 3,
          channels: ["EMAIL", "SMS"],
        },
        uiResources: ["static/rulenode/rulenode-reminder-config.js"],
        configDirective: "tbDueReminderNodeConfig",
      },
    },
  },
  {
    id: { id: "b11c9ac0-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165494101,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Send Initial Reminder",
    clazz: "org.billing.rule.engine.notification.TbSendInitialReminderNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description:
          "Sends due date reminders to users before the bill due date.",
        details: "Configurable reminder intervals and communication channels.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Sent", "Failed"],
        defaultConfiguration: {
          reminderDaysBefore: 3,
          channels: ["EMAIL", "SMS"],
        },
        uiResources: ["static/rulenode/rulenode-reminder-config.js"],
        configDirective: "tbDueReminderNodeConfig",
      },
    },
  },
  {
    id: { id: "b11ccad0-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165494101,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Send Final Reminder",
    clazz: "org.billing.rule.engine.notification.TbSendFinalReminderNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description:
          "Sends due date reminders to users before the bill due date.",
        details: "Configurable reminder intervals and communication channels.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Sent", "Failed"],
        defaultConfiguration: {
          reminderDaysBefore: 3,
          channels: ["EMAIL", "SMS"],
        },
        uiResources: ["static/rulenode/rulenode-reminder-config.js"],
        configDirective: "tbDueReminderNodeConfig",
      },
    },
  },
  {
    id: { id: "a21c7280-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165494101,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Due Reminder Scheduler",
    clazz: "org.thingsboard.rule.engine.transform.TbTransformNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description:
          "Sends due date reminders to users before the bill due date.",
        details: "Configurable reminder intervals and communication channels.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Sent", "Failed"],
        defaultConfiguration: {
          reminderDaysBefore: 3,
          channels: ["EMAIL", "SMS"],
        },
        uiResources: ["static/rulenode/rulenode-reminder-config.js"],
        configDirective: "tbDueReminderNodeConfig",
      },
    },
  },
  {
    id: { id: "bdue-401-11ef-a60f-836bea56f698" },
    createdTime: 1739165492401,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Pre-Due Reminder Sender",
    clazz: "org.billing.rule.engine.reminder.TbPreDueReminderNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Sends reminders 3 days before due date.",
        relationTypes: ["Sent", "Failure"],
        defaultConfiguration: {
          reminderDaysBefore: 3,
          sendSMS: true,
        },
      },
    },
  },
  {
    id: { id: "bdue-402-11ef-a60f-836bea56f698" },
    createdTime: 1739165492402,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Overdue Notice Trigger",
    clazz: "org.billing.rule.engine.reminder.TbOverdueNoticeNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Sends overdue notification after due date.",
        relationTypes: ["Sent", "Failure"],
        defaultConfiguration: {
          daysAfterDue: 1,
          emailTemplate: "overdue-template",
        },
      },
    },
  },
  {
    id: { id: "b11c6ab0-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492402,
    type: "BILL_DUE_REMINDER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Determine Reminder Stage",
    clazz: "org.thingsboard.rule.engine.transform.TbReminderStageNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Sends overdue notification after due date.",
        relationTypes: ["Sent", "Failure"],
        defaultConfiguration: {
          daysAfterDue: 1,
          emailTemplate: "overdue-template",
        },
      },
    },
  },

  // BILL_APPROVAL
  {
    id: { id: "bapr-105-11ef-a60f-836bea56f698" },
    createdTime: 1739165496101,
    type: "BILL_APPROVAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Bill Approval Workflow",
    clazz: "org.billing.rule.engine.approval.TbBillApprovalNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Approves validated bills before payment.",
        details: "Supports auto-approval based on policy or manual review.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Approved", "Rejected"],
        defaultConfiguration: {
          autoApproveBelowAmount: 5000,
          notifyOnReject: true,
        },
        uiResources: ["static/rulenode/rulenode-approval-config.js"],
        configDirective: "tbBillApprovalNodeConfig",
      },
    },
  },

  {
    id: { id: "bapp-501-11ef-a60f-836bea56f698" },
    createdTime: 1739165492501,
    type: "BILL_APPROVAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Auto Approver Node",
    clazz: "org.billing.rule.engine.approval.TbAutoApprovalNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Approves bills automatically below a limit.",
        defaultConfiguration: {
          autoApproveLimit: 2000,
        },
        relationTypes: ["Approved", "Rejected"],
      },
    },
  },
  {
    id: { id: "a21b7280-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492501,
    type: "BILL_APPROVAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Approval Status Check",
    clazz: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Approves bills automatically below a limit.",
        defaultConfiguration: {
          autoApproveLimit: 2000,
        },
        relationTypes: ["Approved", "Rejected"],
      },
    },
  },
  {
    id: { id: "bapp-502-11ef-a60f-836bea56f698" },
    createdTime: 1739165492502,
    type: "BILL_APPROVAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Manager Approval Node",
    clazz: "org.billing.rule.engine.approval.TbManagerApprovalNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Routes high-value bills for manual approval.",
        defaultConfiguration: {
          threshold: 10000,
          approverRole: "MANAGER",
        },
      },
    },
  },
  {
    id: { id: "a1130b10-18e4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492502,
    type: "BILL_APPROVAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Send for Approval",
    clazz: "org.thingsboard.rule.engine.rest.TbRestApiCallNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Routes high-value bills for manual approval.",
        defaultConfiguration: {
          threshold: 10000,
          approverRole: "MANAGER",
        },
      },
    },
  },

  // BILL_PAYMENT
  {
    id: { id: "bpay-106-11ef-a60f-836bea56f698" },
    createdTime: 1739165497101,
    type: "BILL_PAYMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Payment Handler",
    clazz: "org.billing.rule.engine.payment.TbBillPaymentNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Processes payments for approved bills.",
        details: "Handles payment gateway integrations and receipt generation.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        defaultConfiguration: {
          paymentMode: "ONLINE",
          retryOnFailure: true,
          maxRetries: 3,
        },
        uiResources: ["static/rulenode/rulenode-payment-config.js"],
        configDirective: "tbBillPaymentNodeConfig",
      },
    },
  },
  {
    id: { id: "bpay-601-11ef-a60f-836bea56f698" },
    createdTime: 1739165492601,
    type: "BILL_PAYMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Online Payment Processor",
    clazz: "org.billing.rule.engine.payment.TbOnlinePaymentNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Processes online payments securely.",
        defaultConfiguration: {
          gateway: "Stripe",
          autoReconcile: true,
        },
      },
    },
  },
  {
    id: { id: "bpay-602-11ef-a60f-836bea56f698" },
    createdTime: 1739165492602,
    type: "BILL_PAYMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Offline Payment Handler",
    clazz: "org.billing.rule.engine.payment.TbOfflinePaymentNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Handles cash or cheque payments.",
        defaultConfiguration: {
          allowPendingStatus: true,
        },
      },
    },
  },
  {
    id: { id: "a1132de0-18e4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492602,
    type: "BILL_PAYMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Mark Bill as Paid",
    clazz: "org.thingsboard.rule.engine.transform.TbBillTransformNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Handles cash or cheque payments.",
        defaultConfiguration: {
          allowPendingStatus: true,
        },
      },
    },
  },
  {
    id: { id: "a21c0280-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492602,
    type: "BILL_PAYMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Payment Confirmation Check",
    clazz: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Handles cash or cheque payments.",
        defaultConfiguration: {
          allowPendingStatus: true,
        },
      },
    },
  },
  {
    id: { id: "a21ca280-38f4-11f0-93a4-7fc3c20f1d23" },
    createdTime: 1739165492602,
    type: "BILL_PAYMENT",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Billing Report",
    clazz: "org.thingsboard.rule.engine.rest.TbBillingReportNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Handles cash or cheque payments.",
        defaultConfiguration: {
          allowPendingStatus: true,
        },
      },
    },
  },

  // BILL_REVERSAL
  {
    id: { id: "brev-701-11ef-a60f-836bea56f698" },
    createdTime: 1739165492701,
    type: "BILL_REVERSAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Refund Processor",
    clazz: "org.billing.rule.engine.reversal.TbRefundProcessorNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Issues refunds for overpayments.",
        defaultConfiguration: {
          maxRefundDays: 30,
        },
      },
    },
  },
  {
    id: { id: "brev-702-11ef-a60f-836bea56f698" },
    createdTime: 1739165492702,
    type: "BILL_REVERSAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Duplicate Bill Reversal",
    clazz: "org.billing.rule.engine.reversal.TbDuplicateReversalNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Reverses duplicated bills.",
        defaultConfiguration: {
          detectDuplicateBy: "INVOICE_NO",
        },
      },
    },
  },
  {
    id: { id: "a21c3280-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492702,
    type: "BILL_REVERSAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Initiate Reversal",
    clazz: "org.thingsboard.rule.engine.rest.TbRestApiCallNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Reverses duplicated bills.",
        defaultConfiguration: {
          detectDuplicateBy: "INVOICE_NO",
        },
      },
    },
  },
  {
    id: { id: "a21bd280-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492702,
    type: "BILL_REVERSAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Initiate Payment",
    clazz: "org.thingsboard.rule.engine.rest.TbRestApiCallNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Reverses duplicated bills.",
        defaultConfiguration: {
          detectDuplicateBy: "INVOICE_NO",
        },
      },
    },
  },
  {
    id: { id: "b11cfae0-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492702,
    type: "BILL_REVERSAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Apply Late Fee",
    clazz: "org.billing.rule.engine.notification.TbSendOverdueNoticeNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Reverses duplicated bills.",
        defaultConfiguration: {
          detectDuplicateBy: "INVOICE_NO",
        },
      },
    },
  },

  // BILL_REPORTING
  {
    id: { id: "brep-801-11ef-a60f-836bea56f698" },
    createdTime: 1739165492801,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Monthly Summary Report",
    clazz: "org.billing.rule.engine.reporting.TbMonthlyReportNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Generates monthly billing summary reports.",
        defaultConfiguration: {
          format: "PDF",
          includeCharts: true,
        },
      },
    },
  },
  {
    id: { id: "b11d1af0-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492801,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Send Overdue Notice",
    clazz: "org.thingsboard.rule.engine.rest.TbSendOverdueNoticeNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Generates monthly billing summary reports.",
        defaultConfiguration: {
          format: "PDF",
          includeCharts: true,
        },
      },
    },
  },
  {
    id: { id: "brep-802-11ef-a60f-836bea56f698" },
    createdTime: 1739165492802,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Customer Billing History Export",
    clazz: "org.billing.rule.engine.reporting.TbBillingHistoryExportNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Exports customer billing data to CSV.",
        defaultConfiguration: {
          fields: ["invoiceId", "amount", "status", "date"],
          compression: "ZIP",
        },
      },
    },
  },
  {
    id: { id: "a1131c70-18e4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492802,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Log Rejected Bills",
    clazz: "org.thingsboard.rule.engine.action.TbLogNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Logs rejected bills with invalid data.",
        defaultConfiguration: {
          scriptLang: "TBEL",
          tbelScript: `return "\\nRejected Bill: Invalid amount or data.\\nDetails:\\n" + JSON.stringify(msg);`,
        },
      },
    },
  },
  {
    id: { id: "a21ba280-38f4-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492802,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Rejected Bill Retry Handler",
    clazz: "org.thingsboard.rule.engine.transform.TbTransformNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Logs rejected bills with invalid data.",
        defaultConfiguration: {
          scriptLang: "TBEL",
          tbelScript: `return "\\nRejected Bill: Invalid amount or data.\\nDetails:\\n" + JSON.stringify(msg);`,
        },
      },
    },
  },
  {
    id: { id: "a11c3aa0-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492802,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Invalid Bill Log",
    clazz: "org.thingsboard.rule.engine.action.TbInvalidBillLogNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Logs rejected bills with invalid data.",
        defaultConfiguration: {
          scriptLang: "TBEL",
          tbelScript: `return "\\nRejected Bill: Invalid amount or data.\\nDetails:\\n" + JSON.stringify(msg);`,
        },
      },
    },
  },
  {
    id: { id: "b11d3b00-39a5-11f0-93a4-7fc3c203433" },
    createdTime: 1739165492802,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Log Reminder Status",
    clazz: "org.thingsboard.rule.engine.action.TbReminderResultLogNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Logs rejected bills with invalid data.",
        defaultConfiguration: {
          scriptLang: "TBEL",
          tbelScript: `return "\\nRejected Bill: Invalid amount or data.\\nDetails:\\n" + JSON.stringify(msg);`,
        },
      },
    },
  },
  {
    id: { id: "b11d6b10-39a5-11f0-93a4-7fc3c20f1a11" },
    createdTime: 1739165492802,
    type: "BILL_REPORTING",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "Send Reminder Report",
    clazz: "org.billing.rule.engine.reporting.TbBillingHistoryExportNode",
    configurationVersion: 0,
    configurationDescriptor: {
      nodeDefinition: {
        description: "Logs rejected bills with invalid data.",
        defaultConfiguration: {
          scriptLang: "TBEL",
          tbelScript: `return "\\nRejected Bill: Invalid amount or data.\\nDetails:\\n" + JSON.stringify(msg);`,
        },
      },
    },
  },
];

export const BuildModuleRule1MetaDataDummyData1 = {
  ruleChainId: {
    entityType: "RULE_CHAIN",
    id: "a3358fd0-03d1-11f0-9f1a-2db71be85a80",
  },
  version: 12,
  firstNodeIndex: 0,
  nodes: [
    {
      id: {
        entityType: "RULE_NODE",
        id: "a112e980-18e4-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.transform.TbTransformNode",
      name: "Generate Bill",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1746595432000,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          '// Generate new bill payload\nif (msg != null && msg.customerId && msg.usage) {\n    var billAmount = msg.usage * 6.5; // tariff * usage\n    msg.billId = "BILL-" + Date.now();\n    msg.billAmount = billAmount.toFixed(2);\n    msg.status = "GENERATED";\n    return msg;\n} else {\n    return { error: "Invalid data for bill generation" };\n}',
      },
      additionalInfo: {
        description: "Generates bill details using usage data",
        layoutX: 250,
        layoutY: 160,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "a112fa40-18e4-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
      name: "Validate Bill Amount",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1746595459000,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          "// Check bill amount validity\nif (msg.billAmount != null && msg.billAmount > 0 && msg.billAmount < 100000) {\n    return true;\n} else {\n    return false;\n}",
      },
      additionalInfo: {
        description: "Ensures the generated bill has a valid total amount",
        layoutX: 480,
        layoutY: 160,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "a1130b10-18e4-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.rest.TbRestApiCallNode",
      name: "Send for Approval",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1746595484000,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 1,
      configuration: {
        restEndpointUrlPattern: "http://localhost:8080/api/bill/approve",
        requestMethod: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: {
          type: "anonymous",
        },
        parseToPlainText: false,
        ignoreRequestBody: false,
      },
      additionalInfo: {
        description: "Sends valid bills to approval API",
        layoutX: 820,
        layoutY: 130,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "a1131c70-18e4-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.action.TbLogNode",
      name: "Log Rejected Bills",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1746595484000,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          'return "\\nRejected Bill: Invalid amount or data.\\nDetails:\\n" + JSON.stringify(msg);',
      },
      additionalInfo: {
        description: "Logs rejected bills with invalid data",
        layoutX: 820,
        layoutY: 260,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "a21ca280-38f4-11f0-93a4-7fc3c20f1d23",
      },
      type: "org.thingsboard.rule.engine.rest.TbBillingReportNode",
      name: "Billing Report",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1746595484000,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          'if (msg.status === "APPROVED") {\n    msg.status = "PAID";\n    msg.paymentDate = new Date().toISOString();\n    return msg;\n} else {\n    return { note: "Bill not approved yet" };\n}',
      },
      additionalInfo: {
        description: "Final transformation marking bill as paid after approval",
        layoutX: 1070.807839388145,
        layoutY: 132.46175908221795,
      },
    },
  ],
  connections: [
    {
      fromIndex: 0,
      toIndex: 1,
      type: "Success",
    },
    {
      fromIndex: 1,
      toIndex: 2,
      type: "True",
    },
    {
      fromIndex: 1,
      toIndex: 3,
      type: "False",
    },
    {
      fromIndex: 2,
      toIndex: 4,
      type: "Success",
    },
  ],
};

const VeeRuleDummyData = [
  {
    id: {
      id: "48b883a0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491418,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "aws sqs",
    clazz: "org.thingsboard.rule.engine.aws.sqs.TbSqsNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will publish message payload and metadata attributes to the AWS SQS queue. Outbound message will contain response fields (<code>messageId</code>, <code>requestId</code>, <code>messageBodyMd5</code>, <code>messageAttributesMd5</code>, <code>sequenceNumber</code>) in the Message Metadata from the AWS SQS. For example <b>requestId</b> field can be accessed with <code>metadata.requestId</code>.",
        description: "Publish messages to the AWS SQS",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          queueType: "STANDARD",
          queueUrlPattern:
            "https://sqs.us-east-1.amazonaws.com/123456789012/my-queue-name",
          delaySeconds: 0,
          messageAttributes: {},
          accessKeyId: null,
          secretAccessKey: null,
          region: "us-east-1",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeSqsConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4Ij48cGF0aCBkPSJNMTMuMjMgMTAuNTZWMTBjLTEuOTQgMC0zLjk5LjM5LTMuOTkgMi42NyAwIDEuMTYuNjEgMS45NSAxLjYzIDEuOTUuNzYgMCAxLjQzLS40NyAxLjg2LTEuMjIuNTItLjkzLjUtMS44LjUtMi44NG0yLjcgNi41M2MtLjE4LjE2LS40My4xNy0uNjMuMDYtLjg5LS43NC0xLjA1LTEuMDgtMS41NC0xLjc5LTEuNDcgMS41LTIuNTEgMS45NS00LjQyIDEuOTUtMi4yNSAwLTQuMDEtMS4zOS00LjAxLTQuMTcgMC0yLjE4IDEuMTctMy42NCAyLjg2LTQuMzggMS40Ni0uNjQgMy40OS0uNzYgNS4wNC0uOTNWNy41YzAtLjY2LjA1LTEuNDEtLjMzLTEuOTYtLjMyLS40OS0uOTUtLjctMS41LS43LTEuMDIgMC0xLjkzLjUzLTIuMTUgMS42MS0uMDUuMjQtLjI1LjQ4LS40Ny40OWwtMi42LS4yOGMtLjIyLS4wNS0uNDYtLjIyLS40LS41Ni42LTMuMTUgMy40NS00LjEgNi00LjEgMS4zIDAgMyAuMzUgNC4wMyAxLjMzQzE3LjExIDQuNTUgMTcgNi4xOCAxNyA3Ljk1djQuMTdjMCAxLjI1LjUgMS44MSAxIDIuNDguMTcuMjUuMjEuNTQgMCAuNzFsLTIuMDYgMS43OGgtLjAxIj48L3BhdGg+PHBhdGggZD0iTTIwLjE2IDE5LjU0QzE4IDIxLjE0IDE0LjgyIDIyIDEyLjEgMjJjLTMuODEgMC03LjI1LTEuNDEtOS44NS0zLjc2LS4yLS4xOC0uMDItLjQzLjI1LS4yOSAyLjc4IDEuNjMgNi4yNSAyLjYxIDkuODMgMi42MSAyLjQxIDAgNS4wNy0uNSA3LjUxLTEuNTMuMzctLjE2LjY2LjI0LjMyLjUxIj48L3BhdGg+PHBhdGggZD0iTTIxLjA3IDE4LjVjLS4yOC0uMzYtMS44NS0uMTctMi41Ny0uMDgtLjE5LjAyLS4yMi0uMTYtLjAzLS4zIDEuMjQtLjg4IDMuMjktLjYyIDMuNTMtLjMzLjI0LjMtLjA3IDIuMzUtMS4yNCAzLjMyLS4xOC4xNi0uMzUuMDctLjI2LS4xMS4yNi0uNjcuODUtMi4xNC41Ny0yLjV6Ij48L3BhdGg+PC9zdmc+",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48c3f550-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491493,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "send email",
    clazz: "org.thingsboard.rule.engine.mail.TbSendEmailNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Expects messages with <b>SEND_EMAIL</b> type. Node works only with messages that  where created using <code>to Email</code> transformation Node, please connect this Node with <code>to Email</code> Node using <code>Successful</code> chain.",
        description: "Sends email message via SMTP server.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          useSystemSmtpSettings: true,
          smtpHost: "localhost",
          smtpPort: 25,
          username: null,
          password: null,
          smtpProtocol: "smtp",
          timeout: 10000,
          enableTls: false,
          tlsVersion: "TLSv1.2",
          enableProxy: false,
          proxyHost: null,
          proxyPort: null,
          proxyUser: null,
          proxyPassword: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeSendEmailConfig",
        icon: "send",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48c97390-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491529,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "send sms",
    clazz: "org.thingsboard.rule.engine.sms.TbSendSmsNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will send SMS message by populating target phone numbers and sms message fields using values derived from message metadata.",
        description: "Sends SMS message via SMS provider.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          numbersToTemplate: "${userPhone}",
          smsMessageTemplate:
            "Device ${deviceName} has high temperature ${temp}",
          useSystemSmsSettings: true,
          smsProviderConfiguration: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeSendSmsConfig",
        icon: "sms",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48df93a0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491674,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "aws lambda",
    clazz: "org.thingsboard.rule.engine.aws.lambda.TbAwsLambdaNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Publishes messages to AWS Lambda, a service that lets you run code without provisioning or managing servers. It sends messages using a RequestResponse invocation type. The node uses a pre-configured client and specified function to run.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description: "Publish message to the AWS Lambda",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          accessKey: null,
          secretKey: null,
          region: "us-east-1",
          functionName: null,
          qualifier: "$LATEST",
          connectionTimeout: 10,
          requestTimeout: 5,
          tellFailureIfFuncThrowsExc: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeLambdaConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4Ij48cGF0aCBkPSJNMTMuMjMgMTAuNTZWMTBjLTEuOTQgMC0zLjk5LjM5LTMuOTkgMi42NyAwIDEuMTYuNjEgMS45NSAxLjYzIDEuOTUuNzYgMCAxLjQzLS40NyAxLjg2LTEuMjIuNTItLjkzLjUtMS44LjUtMi44NG0yLjcgNi41M2MtLjE4LjE2LS40My4xNy0uNjMuMDYtLjg5LS43NC0xLjA1LTEuMDgtMS41NC0xLjc5LTEuNDcgMS41LTIuNTEgMS45NS00LjQyIDEuOTUtMi4yNSAwLTQuMDEtMS4zOS00LjAxLTQuMTcgMC0yLjE4IDEuMTctMy42NCAyLjg2LTQuMzggMS40Ni0uNjQgMy40OS0uNzYgNS4wNC0uOTNWNy41YzAtLjY2LjA1LTEuNDEtLjMzLTEuOTYtLjMyLS40OS0uOTUtLjctMS41LS43LTEuMDIgMC0xLjkzLjUzLTIuMTUgMS42MS0uMDUuMjQtLjI1LjQ4LS40Ny40OWwtMi42LS4yOGMtLjIyLS4wNS0uNDYtLjIyLS40LS41Ni42LTMuMTUgMy40NS00LjEgNi00LjEgMS4zIDAgMyAuMzUgNC4wMyAxLjMzQzE3LjExIDQuNTUgMTcgNi4xOCAxNyA3Ljk1djQuMTdjMCAxLjI1LjUgMS44MSAxIDIuNDguMTcuMjUuMjEuNTQgMCAuNzFsLTIuMDYgMS43OGgtLjAxIj48L3BhdGg+PHBhdGggZD0iTTIwLjE2IDE5LjU0QzE4IDIxLjE0IDE0LjgyIDIyIDEyLjEgMjJjLTMuODEgMC03LjI1LTEuNDEtOS44NS0zLjc2LS4yLS4xOC0uMDItLjQzLjI1LS4yOSAyLjc4IDEuNjMgNi4yNSAyLjYxIDkuODMgMi42MSAyLjQxIDAgNS4wNy0uNSA3LjUxLTEuNTMuMzctLjE2LjY2LjI0LjMyLjUxIj48L3BhdGg+PHBhdGggZD0iTTIxLjA3IDE4LjVjLS4yOC0uMzYtMS44NS0uMTctMi41Ny0uMDgtLjE5LjAyLS4yMi0uMTYtLjAzLS4zIDEuMjQtLjg4IDMuMjktLjYyIDMuNTMtLjMzLjI0LjMtLjA3IDIuMzUtMS4yNCAzLjMyLS4xOC4xNi0uMzUuMDctLjI2LS4xMS4yNi0uNjcuODUtMi4xNC41Ny0yLjV6Ij48L3BhdGg+PC9zdmc+",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49160cf0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492031,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "gcp pubsub",
    clazz: "org.thingsboard.rule.engine.gcp.pubsub.TbPubSubNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will publish message payload to the Google Cloud Platform PubSub topic. Outbound message will contain response fields (<code>messageId</code> in the Message Metadata from the GCP PubSub. <b>messageId</b> field can be accessed with <code>metadata.messageId</code>.",
        description: "Publish message to the Google Cloud PubSub",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          projectId: "my-google-cloud-project-id",
          topicName: "my-pubsub-topic-name",
          messageAttributes: {},
          serviceAccountKey: null,
          serviceAccountKeyFileName: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodePubSubConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,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",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49344350-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492229,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "SINGLETON",
    name: "azure iot hub",
    clazz: "org.thingsboard.rule.engine.mqtt.azure.TbAzureIotHubNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will publish message payload to the Azure IoT Hub with QoS <b>AT_LEAST_ONCE</b>.",
        description: "Publish messages to the Azure IoT Hub",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          topicPattern: "devices/<device_id>/messages/events/",
          host: "<iot-hub-name>.azure-devices.net",
          port: 8883,
          connectTimeoutSec: 10,
          clientId: null,
          appendClientIdSuffix: false,
          retainedMessage: false,
          cleanSession: true,
          ssl: true,
          parseToPlainText: false,
          credentials: {
            type: "sas",
            caCert: null,
            cert: null,
            privateKey: null,
            password: null,
            sasKey: null,
          },
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeAzureIotHubConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49366630-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492243,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "aws sns",
    clazz: "org.thingsboard.rule.engine.aws.sns.TbSnsNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will publish message payload to the AWS SNS topic. Outbound message will contain response fields (<code>messageId</code>, <code>requestId</code>) in the Message Metadata from the AWS SNS. For example <b>requestId</b> field can be accessed with <code>metadata.requestId</code>.",
        description: "Publish message to the AWS SNS",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          topicArnPattern: "arn:aws:sns:us-east-1:123456789012:MyNewTopic",
          accessKeyId: null,
          secretAccessKey: null,
          region: "us-east-1",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeSnsConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4Ij48cGF0aCBkPSJNMTMuMjMgMTAuNTZWMTBjLTEuOTQgMC0zLjk5LjM5LTMuOTkgMi42NyAwIDEuMTYuNjEgMS45NSAxLjYzIDEuOTUuNzYgMCAxLjQzLS40NyAxLjg2LTEuMjIuNTItLjkzLjUtMS44LjUtMi44NG0yLjcgNi41M2MtLjE4LjE2LS40My4xNy0uNjMuMDYtLjg5LS43NC0xLjA1LTEuMDgtMS41NC0xLjc5LTEuNDcgMS41LTIuNTEgMS45NS00LjQyIDEuOTUtMi4yNSAwLTQuMDEtMS4zOS00LjAxLTQuMTcgMC0yLjE4IDEuMTctMy42NCAyLjg2LTQuMzggMS40Ni0uNjQgMy40OS0uNzYgNS4wNC0uOTNWNy41YzAtLjY2LjA1LTEuNDEtLjMzLTEuOTYtLjMyLS40OS0uOTUtLjctMS41LS43LTEuMDIgMC0xLjkzLjUzLTIuMTUgMS42MS0uMDUuMjQtLjI1LjQ4LS40Ny40OWwtMi42LS4yOGMtLjIyLS4wNS0uNDYtLjIyLS40LS41Ni42LTMuMTUgMy40NS00LjEgNi00LjEgMS4zIDAgMyAuMzUgNC4wMyAxLjMzQzE3LjExIDQuNTUgMTcgNi4xOCAxNyA3Ljk1djQuMTdjMCAxLjI1LjUgMS44MSAxIDIuNDguMTcuMjUuMjEuNTQgMCAuNzFsLTIuMDYgMS43OGgtLjAxIj48L3BhdGg+PHBhdGggZD0iTTIwLjE2IDE5LjU0QzE4IDIxLjE0IDE0LjgyIDIyIDEyLjEgMjJjLTMuODEgMC03LjI1LTEuNDEtOS44NS0zLjc2LS4yLS4xOC0uMDItLjQzLjI1LS4yOSAyLjc4IDEuNjMgNi4yNSAyLjYxIDkuODMgMi42MSAyLjQxIDAgNS4wNy0uNSA3LjUxLTEuNTMuMzctLjE2LjY2LjI0LjMyLjUxIj48L3BhdGg+PHBhdGggZD0iTTIxLjA3IDE4LjVjLS4yOC0uMzYtMS44NS0uMTctMi41Ny0uMDgtLjE5LjAyLS4yMi0uMTYtLjAzLS4zIDEuMjQtLjg4IDMuMjktLjYyIDMuNTMtLjMzLjI0LjMtLjA3IDIuMzUtMS4yNCAzLjMyLS4xOC4xNi0uMzUuMDctLjI2LS4xMS4yNi0uNjcuODUtMi4xNC41Ny0yLjV6Ij48L3BhdGg+PC9zdmc+",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "493afa10-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492273,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "send notification",
    clazz: "org.thingsboard.rule.engine.notification.TbNotificationNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will send notification to the specified targets using the template",
        description: "Sends notification to targets using the template",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          targets: null,
          templateId: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeNotificationConfig",
        icon: "notifications",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "493d1cf0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492287,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "kafka",
    clazz: "org.thingsboard.rule.engine.kafka.TbKafkaNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will send record via Kafka producer to Kafka server. Outbound message will contain response fields (<code>offset</code>, <code>partition</code>, <code>topic</code>) from the Kafka in the Message Metadata. For example <b>partition</b> field can be accessed with <code>metadata.partition</code>.",
        description: "Publish messages to Kafka server",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          topicPattern: "my-topic",
          keyPattern: null,
          bootstrapServers: "localhost:9092",
          retries: 0,
          batchSize: 16384,
          linger: 0,
          bufferMemory: 33554432,
          acks: "-1",
          keySerializer:
            "org.apache.kafka.common.serialization.StringSerializer",
          valueSerializer:
            "org.apache.kafka.common.serialization.StringSerializer",
          otherProperties: {},
          addMetadataKeyValuesAsKafkaHeaders: false,
          kafkaHeadersCharset: "UTF-8",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeKafkaConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,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",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "494189c0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492316,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "send to slack",
    clazz: "org.thingsboard.rule.engine.notification.TbSlackNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details: "Sends message to a Slack channel or user",
        description: "Send message via Slack",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          botToken: "xoxb-",
          useSystemSettings: true,
          messageTemplate: "Device ${deviceId}: temperature is $[temperature]",
          conversationType: "PUBLIC_CHANNEL",
          conversation: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeSlackConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTYsMTVBMiwyIDAgMCwxIDQsMTdBMiwyIDAgMCwxIDIsMTVBMiwyIDAgMCwxIDQsMTNINlYxNU03LDE1QTIsMiAwIDAsMSA5LDEzQTIsMiAwIDAsMSAxMSwxNVYyMEEyLDIgMCAwLDEgOSwyMkEyLDIgMCAwLDEgNywyMFYxNU05LDdBMiwyIDAgMCwxIDcsNUEyLDIgMCAwLDEgOSwzQTIsMiAwIDAsMSAxMSw1VjdIOU05LDhBMiwyIDAgMCwxIDExLDEwQTIsMiAwIDAsMSA5LDEySDRBMiwyIDAgMCwxIDIsMTBBMiwyIDAgMCwxIDQsOEg5TTE3LDEwQTIsMiAwIDAsMSAxOSw4QTIsMiAwIDAsMSAyMSwxMEEyLDIgMCAwLDEgMTksMTJIMTdWMTBNMTYsMTBBMiwyIDAgMCwxIDE0LDEyQTIsMiAwIDAsMSAxMiwxMFY1QTIsMiAwIDAsMSAxNCwzQTIsMiAwIDAsMSAxNiw1VjEwTTE0LDE4QTIsMiAwIDAsMSAxNiwyMEEyLDIgMCAwLDEgMTQsMjJBMiwyIDAgMCwxIDEyLDIwVjE4SDE0TTE0LDE3QTIsMiAwIDAsMSAxMiwxNUEyLDIgMCAwLDEgMTQsMTNIMTlBMiwyIDAgMCwxIDIxLDE1QTIsMiAwIDAsMSAxOSwxN0gxNFoiIC8+PC9zdmc+",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "494b74d0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492381,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rabbitmq",
    clazz: "org.thingsboard.rule.engine.rabbitmq.TbRabbitMqNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details: "Will publish message payload to RabbitMQ queue.",
        description: "Publish messages to the RabbitMQ",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          exchangeNamePattern: "",
          routingKeyPattern: "",
          messageProperties: null,
          host: "localhost",
          port: 5672,
          virtualHost: "/",
          username: "guest",
          password: "guest",
          automaticRecoveryEnabled: false,
          connectionTimeout: 60000,
          handshakeTimeout: 10000,
          clientProperties: {},
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeRabbitMqConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZlcnNpb249IjEuMSIgeT0iMHB4IiB4PSIwcHgiIHZpZXdCb3g9IjAgMCAxMDAwIDEwMDAiPjxwYXRoIHN0cm9rZS13aWR0aD0iLjg0OTU2IiBkPSJtODYwLjQ3IDQxNi4zMmgtMjYyLjAxYy0xMi45MTMgMC0yMy42MTgtMTAuNzA0LTIzLjYxOC0yMy42MTh2LTI3Mi43MWMwLTIwLjMwNS0xNi4yMjctMzYuMjc2LTM2LjI3Ni0zNi4yNzZoLTkzLjc5MmMtMjAuMzA1IDAtMzYuMjc2IDE2LjIyNy0zNi4yNzYgMzYuMjc2djI3MC44NGMtMC4yNTQ4NyAxNC4xMDMtMTEuNDY5IDI1LjU3Mi0yNS43NDIgMjUuNTcybC04NS42MzYgMC42Nzk2NWMtMTQuMTAzIDAtMjUuNTcyLTExLjQ2OS0yNS41NzItMjUuNTcybDAuNjc5NjUtMjcxLjUyYzAtMjAuMzA1LTE2LjIyNy0zNi4yNzYtMzYuMjc2LTM2LjI3NmgtOTMuNTM3Yy0yMC4zMDUgMC0zNi4yNzYgMTYuMjI3LTM2LjI3NiAzNi4yNzZ2NzYzLjg0YzAgMTguMDk2IDE0Ljc4MiAzMi40NTMgMzIuNDUzIDMyLjQ1M2g3MjIuODFjMTguMDk2IDAgMzIuNDUzLTE0Ljc4MiAzMi40NTMtMzIuNDUzdi00MzUuMzFjLTEuMTg5NC0xOC4xODEtMTUuMjkyLTMyLjE5OC0zMy4zODgtMzIuMTk4em0tMTIyLjY4IDI4Ny4wN2MwIDIzLjYxOC0xOC44NiA0Mi40NzgtNDIuNDc4IDQyLjQ3OGgtNzMuOTk3Yy0yMy42MTggMC00Mi40NzgtMTguODYtNDIuNDc4LTQyLjQ3OHYtNzQuMjUyYzAtMjMuNjE4IDE4Ljg2LTQyLjQ3OCA0Mi40NzgtNDIuNDc4aDczLjk5N2MyMy42MTggMCA0Mi40NzggMTguODYgNDIuNDc4IDQyLjQ3OHoiLz48L3N2Zz4=",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "494de5d0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492397,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "USER_PREFERENCE",
    name: "mqtt",
    clazz: "org.thingsboard.rule.engine.mqtt.TbMqttNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Will publish message payload to the MQTT broker with QoS <b>AT_LEAST_ONCE</b>.",
        description: "Publish messages to the MQTT broker",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          topicPattern: "my-topic",
          host: null,
          port: 1883,
          connectTimeoutSec: 10,
          clientId: null,
          appendClientIdSuffix: false,
          retainedMessage: false,
          cleanSession: true,
          ssl: false,
          parseToPlainText: false,
          credentials: {
            type: "anonymous",
          },
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeMqttConfig",
        icon: "call_split",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49522b90-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492425,
    type: "EXTERNAL",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rest api call",
    clazz: "org.thingsboard.rule.engine.rest.TbRestApiCallNode",
    configurationVersion: 3,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Will invoke REST API call <code>GET | POST | PUT | DELETE</code> to external REST server. Message payload added into Request body. Configured attributes can be added into Headers from Message Metadata. Outbound message will contain response fields (<code>status</code>, <code>statusCode</code>, <code>statusReason</code> and response <code>headers</code>) in the Message Metadata. Response body saved in outbound Message payload. For example <b>statusCode</b> field can be accessed with <code>metadata.statusCode</code>.<br/><b>Note-</b> if you use system proxy properties, the next system proxy properties should be added: "http.proxyHost" and "http.proxyPort" or  "https.proxyHost" and "https.proxyPort" or "socksProxyHost" and "socksProxyPort",and if your proxy with auth, the next ones  should be added: "tb.proxy.user" and "tb.proxy.password" to the thingsboard.conf file.',
        description: "Invoke REST API calls to external REST server",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          restEndpointUrlPattern: "http://localhost/api",
          requestMethod: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          useSimpleClientHttpFactory: false,
          readTimeoutMs: 0,
          maxParallelRequestsCount: 0,
          parseToPlainText: false,
          enableProxy: false,
          useSystemProxyProperties: false,
          proxyHost: null,
          proxyPort: 0,
          proxyUser: null,
          proxyPassword: null,
          proxyScheme: null,
          credentials: {
            type: "anonymous",
          },
          ignoreRequestBody: false,
          maxInMemoryBufferSizeInKb: 256,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbExternalNodeRestApiCallConfig",
        icon: "",
        iconUrl:
          "data:image/svg+xml;base64,PHN2ZyBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHk9IjBweCIgeD0iMHB4Ij48ZyB0cmFuc2Zvcm09Im1hdHJpeCguOTQ5NzUgMCAwIC45NDk3NSAxNy4xMiAyNi40OTIpIj48cGF0aCBkPSJtMTY5LjExIDEwOC41NGMtOS45MDY2IDAuMDczNC0xOS4wMTQgNi41NzI0LTIyLjAxNCAxNi40NjlsLTY5Ljk5MyAyMzEuMDhjLTMuNjkwNCAxMi4xODEgMy4yODkyIDI1LjIyIDE1LjQ2OSAyOC45MSAyLjIyNTkgMC42NzQ4MSA0LjQ5NjkgMSA2LjcyODUgMSA5Ljk3MjEgMCAxOS4xNjUtNi41MTUzIDIyLjE4Mi0xNi40NjdhNi41MjI0IDYuNTIyNCAwIDAgMCAwLjAwMiAtMC4wMDJsNjkuOTktMjMxLjA3YTYuNTIyNCA2LjUyMjQgMCAwIDAgMCAtMC4wMDJjMy42ODU1LTEyLjE4MS0zLjI4Ny0yNS4yMjUtMTUuNDcxLTI4LjkxMi0yLjI4MjUtMC42OTE0NS00LjYxMTYtMS4wMTY5LTYuODk4NC0xem04NC45ODggMGMtOS45MDQ4IDAuMDczNC0xOS4wMTggNi41Njc1LTIyLjAxOCAxNi40NjlsLTY5Ljk4NiAyMzEuMDhjLTMuNjg5OCAxMi4xNzkgMy4yODUzIDI1LjIxNyAxNS40NjUgMjguOTA4IDIuMjI5NyAwLjY3NjQ3IDQuNTAwOCAxLjAwMiA2LjczMjQgMS4wMDIgOS45NzIxIDAgMTkuMTY1LTYuNTE1MyAyMi4xODItMTYuNDY3YTYuNTIyNCA2LjUyMjQgMCAwIDAgMC4wMDIgLTAuMDAybDY5Ljk4OC0yMzEuMDdjMy42OTA4LTEyLjE4MS0zLjI4NTItMjUuMjIzLTE1LjQ2Ny0yOC45MTItMi4yODE0LTAuNjkyMzEtNC42MTA4LTEuMDE4OS02Ljg5ODQtMS4wMDJ6bS0yMTcuMjkgNDIuMjNjLTEyLjcyOS0wLjAwMDg3LTIzLjE4OCAxMC40NTYtMjMuMTg4IDIzLjE4NiAwLjAwMSAxMi43MjggMTAuNDU5IDIzLjE4NiAyMy4xODggMjMuMTg2IDEyLjcyNy0wLjAwMSAyMy4xODMtMTAuNDU5IDIzLjE4NC0yMy4xODYgMC4wMDA4NzYtMTIuNzI4LTEwLjQ1Ni0yMy4xODUtMjMuMTg0LTIzLjE4NnptMCAxNDYuNjRjLTEyLjcyNy0wLjAwMDg3LTIzLjE4NiAxMC40NTUtMjMuMTg4IDIzLjE4NC0wLjAwMDg3MyAxMi43MjkgMTAuNDU4IDIzLjE4OCAyMy4xODggMjMuMTg4IDEyLjcyOC0wLjAwMSAyMy4xODQtMTAuNDYgMjMuMTg0LTIzLjE4OC0wLjAwMS0xMi43MjYtMTAuNDU3LTIzLjE4My0yMy4xODQtMjMuMTg0em0yNzAuNzkgNDIuMjExYy0xMi43MjcgMC0yMy4xODQgMTAuNDU3LTIzLjE4NCAyMy4xODRzMTAuNDU1IDIzLjE4OCAyMy4xODQgMjMuMTg4aDE1NC45OGMxMi43MjkgMCAyMy4xODYtMTAuNDYgMjMuMTg2LTIzLjE4OCAwLjAwMS0xMi43MjgtMTAuNDU4LTIzLjE4NC0yMy4xODYtMjMuMTg0eiIgdHJhbnNmb3JtPSJtYXRyaXgoMS4wMzc2IDAgMCAxLjAzNzYgLTcuNTY3NiAtMTQuOTI1KSIgc3Ryb2tlLXdpZHRoPSIxLjI2OTMiLz48L2c+PC9zdmc+",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48f3b7e0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491806,
    type: "FLOW",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "output",
    clazz: "org.thingsboard.rule.engine.flow.TbRuleChainOutputNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Produces output of the rule chain processing. The output is forwarded to the caller rule chain, as an output of the corresponding "input" rule node. The output rule node name corresponds to the relation type of the output message, and it is used to forward messages to other rule nodes in the caller rule chain. ',
        description: "transfers the message to the caller rule chain",
        inEnabled: true,
        outEnabled: false,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFlowNodeRuleChainOutputConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4911c730-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492003,
    type: "FLOW",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "checkpoint",
    clazz: "org.thingsboard.rule.engine.flow.TbCheckpointNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: true,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "After successful transfer incoming message is automatically acknowledged. Queue name is configurable.",
        description: "transfers the message to another queue",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49291fc0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492156,
    type: "FLOW",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rule chain",
    clazz: "org.thingsboard.rule.engine.flow.TbRuleChainInputNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "The incoming message is forwarded to the input node of target rule chain. If 'Forward message to the originator's default rule chain' is enabled, then target rule chain might be resolved dynamically based on incoming message originator. In this case rule chain specified in the configuration will be used as fallback rule chain.<br><br>Output connections: <i>Any connection(s) produced by output node(s) in the target rule chain.</i>",
        description: "Transfers the message to another rule chain",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Failure"],
        customRelations: true,
        ruleChainNode: true,
        defaultConfiguration: {
          ruleChainId: null,
          forwardMsgToDefaultRuleChain: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFlowNodeRuleChainInputConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "492acd70-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492167,
    type: "FLOW",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "acknowledge",
    clazz: "org.thingsboard.rule.engine.flow.TbAckNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "After acknowledgement, the message is pushed to related rule nodes. Useful if you don't care what happens to this message next.",
        description: "Acknowledges the incoming message",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48bc0610-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491441,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "push to edge",
    clazz: "org.thingsboard.rule.engine.edge.TbMsgPushToEdgeNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Push messages from cloud to edge. Message originator must be assigned to particular edge or message originator is <b>EDGE</b> entity itself. This node used only on cloud instances to push messages from cloud to edge. Once message arrived into this node it’s going to be converted into edge event and saved to the database. Node doesn't push messages directly to edge, but stores event(s) in the edge queue. Supports next message types:<br><code>POST_TELEMETRY_REQUEST</code><br><code>POST_ATTRIBUTES_REQUEST</code><br><code>ATTRIBUTES_UPDATED</code><br><code>ATTRIBUTES_DELETED</code><br><code>ALARM</code><br><br>Message will be routed via <b>Failure</b> route if node was not able to save edge event to database or unsupported message type arrived. In case successful storage edge event to database message will be routed via <b>Success</b> route.",
        description: "Push messages from cloud to edge",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          scope: "SERVER_SCOPE",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodePushToEdgeConfig",
        icon: "cloud_download",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48be7710-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491457,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "log",
    clazz: "org.thingsboard.rule.engine.action.TbLogNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Transform incoming Message with configured JS function to String and log final value into Thingsboard log file. Message payload can be accessed via <code>msg</code> property. For example <code>'temperature = ' + msg.temperature ;</code>. Message metadata can be accessed via <code>metadata</code> property. For example <code>'name = ' + metadata.customerName;</code>.",
        description:
          "Log incoming messages using JS script for transformation Message into String",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          scriptLang: "TBEL",
          jsScript:
            "return '\\nIncoming message:\\n' + JSON.stringify(msg) + '\\nIncoming metadata:\\n' + JSON.stringify(metadata);",
          tbelScript:
            "return '\\nIncoming message:\\n' + JSON.stringify(msg) + '\\nIncoming metadata:\\n' + JSON.stringify(metadata);",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeLogConfig",
        icon: "menu",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48c15d40-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491476,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "clear alarm",
    clazz: "org.thingsboard.rule.engine.action.TbClearAlarmNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Details - JS function that creates JSON object based on incoming message. This object will be added into Alarm.details field.\nNode output:\nIf alarm was not cleared, original message is returned. Otherwise new Message returned with type 'ALARM', Alarm object in 'msg' property and 'metadata' will contains 'isClearedAlarm' property. Message payload can be accessed via <code>msg</code> property. For example <code>'temperature = ' + msg.temperature ;</code>. Message metadata can be accessed via <code>metadata</code> property. For example <code>'name = ' + metadata.customerName;</code>.",
        description: "Clear Alarm",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Cleared", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          alarmType: "General Alarm",
          scriptLang: "TBEL",
          alarmDetailsBuildJs:
            "var details = {};\nif (metadata.prevAlarmDetails) {\n    details = JSON.parse(metadata.prevAlarmDetails);\n    //remove prevAlarmDetails from metadata\n    delete metadata.prevAlarmDetails;\n    //now metadata is the same as it comes IN this rule node\n}\n\n\nreturn details;",
          alarmDetailsBuildTbel:
            "var details = {};\nif (metadata.prevAlarmDetails != null) {\n    details = JSON.parse(metadata.prevAlarmDetails);\n    //remove prevAlarmDetails from metadata\n    metadata.remove('prevAlarmDetails');\n    //now metadata is the same as it comes IN this rule node\n}\n\n\nreturn details;",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeClearAlarmConfig",
        icon: "notifications_off",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48d0c690-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491577,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "delete relation",
    clazz: "org.thingsboard.rule.engine.action.TbDeleteRelationNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful when you need to remove relations between entities dynamically depending on incoming message payload, message originator type, name, etc.<br><br>If <strong>Delete relation with specific entity</strong> enabled, target entity to delete relation with should be specified. Otherwise, rule node will delete all relations with the message originator based on the configured direction and type.<br><br>Target entity configuration: <ul><li><strong>Device</strong> - use a device with the specified name as the target entity to delete relation with.</li><li><strong>Asset</strong> - use an asset with the specified name as the target entity to delete relation with.</li><li><strong>Entity View</strong> - use entity view with the specified name as the target entity to delete relation with.</li><li><strong>Tenant</strong> - use current tenant as target entity to delete relation with.</li><li><strong>Customer</strong> - use customer with the specified title as the target entity to delete relation with.</li><li><strong>Dashboard</strong> - use a dashboard with the specified title as the target entity to delete relation with.</li><li><strong>User</strong> - use a user with the specified email as the target entity to delete relation with.</li><li><strong>Edge</strong> - use an edge with the specified name as the target entity to delete relation with.</li></ul>Output connections: <code>Success</code> - If the relation(s) successfully deleted, otherwise <code>Failure</code>.",
        description:
          "Deletes relation with the incoming message originator based on the configured direction and type.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          direction: "FROM",
          relationType: "Contains",
          entityType: null,
          entityNamePattern: "",
          entityTypePattern: null,
          deleteForSingleEntity: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeDeleteRelationConfig",
        icon: "remove_circle",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48d5cfa0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491610,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "delete attributes",
    clazz: "org.thingsboard.rule.engine.telemetry.TbMsgDeleteAttributesNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Attempt to remove attributes by selected keys. If msg originator doesn\'t have an attribute with  a key selected in the configuration, it will be ignored. If delete operation is completed successfully,  rule node will send the "Attributes Deleted" event to the root chain of the message originator and  send the incoming message via <b>Success</b> chain, otherwise, <b>Failure</b> chain is used.',
        description: "Delete attributes for Message Originator.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          scope: "SERVER_SCOPE",
          keys: [],
          sendAttributesDeletedNotification: false,
          notifyDevice: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeDeleteAttributesConfig",
        icon: "remove_circle",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48ea6910-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491745,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "copy to view",
    clazz:
      "org.thingsboard.rule.engine.action.TbCopyAttributesToEntityViewNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Copy attributes from asset/device to related entity view according to entity view configuration. \n Copy will be done only for attributes that are between start and end dates and according to attribute keys configuration. \nChanges message originator to related entity view and produces new messages according to count of updated entity views",
        description:
          "Copy attributes from asset/device to entity view and changes message originator to related entity view",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "content_copy",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48ef9930-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491779,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "message count",
    clazz: "org.thingsboard.rule.engine.action.TbMsgCountNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Count incoming messages for specified interval and produces POST_TELEMETRY_REQUEST msg with messages count",
        description: "Count incoming messages",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          telemetryPrefix: "messageCount",
          interval: 1,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeMsgCountConfig",
        icon: "functions",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48f1bc10-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491793,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "synchronization start",
    clazz: "org.thingsboard.rule.engine.transaction.TbSynchronizationBeginNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'This node should be used together with "synchronization end" node. \n This node will put messages into queue based on message originator id. \nSubsequent messages will not be processed until the previous message processing is completed or timeout event occurs.\nSize of the queue per originator and timeout values are configurable on a system level',
        description: 'This Node is now deprecated. Use "Checkpoint" instead.',
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48fa2080-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491848,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rpc call request",
    clazz: "org.thingsboard.rule.engine.rpc.TbSendRPCRequestNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Expects messages with "method" and "params". Will forward response from device to next nodes.If the RPC call request is originated by REST API call from user, will forward the response to user immediately.',
        description: "Sends RPC call to device",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          timeoutInSeconds: 60,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeRpcRequestConfig",
        icon: "call_made",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48feb460-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491878,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "math function",
    clazz: "org.thingsboard.rule.engine.math.TbMathNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Supports math operations like: ADD, SUB, MULT, DIV, etc and functions: SIN, COS, TAN, SEC, etc. Use 'CUSTOM' operation to specify complex math expressions.<br/><br/>You may use constant, message field, metadata field, attribute, and latest time-series as an arguments values. The result of the function may be also stored to message field, metadata field, attribute or time-series value.<br/><br/>Primary use case for this rule node is to take one or more values from the database and modify them based on data from the message. For example, you may increase `totalWaterConsumption` based on the `deltaWaterConsumption` reported by device.<br/><br/>Alternative use case is the replacement of simple JS `script` nodes with more light-weight and performant implementation. For example, you may transform Fahrenheit to Celsius (C = (F - 32) / 1.8) using CUSTOM operation and expression: (x - 32) / 1.8).<br/><br/>The execution is synchronized in scope of message originator (e.g. device) and server node. If you have rule nodes in different rule chains, they will process messages from the same originator synchronously in the scope of the server node.",
        description:
          "Apply math function and save the result into the message and/or database",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          operation: "CUSTOM",
          arguments: [
            {
              name: "x",
              type: "MESSAGE_BODY",
              key: "temperature",
              attributeScope: null,
              defaultValue: null,
            },
          ],
          customFunction: "(x - 32) / 1.8",
          result: {
            type: "MESSAGE_BODY",
            key: "temperatureCelsius",
            resultValuePrecision: 2,
            addToBody: false,
            addToMetadata: false,
            attributeScope: null,
          },
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeMathFunctionConfig",
        icon: "calculate",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4900b030-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491891,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rest call reply",
    clazz: "org.thingsboard.rule.engine.rest.TbSendRestApiCallReplyNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Expects messages with any message type. Forwards incoming message as a reply to REST API call sent to rule engine.",
        description: "Sends reply to REST API call to rule engine",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          serviceIdMetaDataAttribute: "serviceId",
          requestIdMetaDataAttribute: "requestUUID",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeSendRestApiCallReplyConfig",
        icon: "call_merge",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "490989d0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491949,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "generator",
    clazz: "org.thingsboard.rule.engine.debug.TbMsgGeneratorNode",
    configurationVersion: 2,
    actions: null,
    hasQueueName: true,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Generates messages with configurable period. Javascript function used for message generation.",
        description: "Periodically generates messages",
        inEnabled: false,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          msgCount: 0,
          periodInSeconds: 1,
          originatorId: null,
          originatorType: "RULE_NODE",
          scriptLang: "TBEL",
          jsScript:
            'var msg = { temp: 42, humidity: 77 };\nvar metadata = { data: 40 };\nvar msgType = "POST_TELEMETRY_REQUEST";\n\nreturn { msg: msg, metadata: metadata, msgType: msgType };',
          tbelScript:
            'var msg = { temp: 42, humidity: 77 };\nvar metadata = { data: 40 };\nvar msgType = "POST_TELEMETRY_REQUEST";\n\nreturn { msg: msg, metadata: metadata, msgType: msgType };',
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeGeneratorConfig",
        icon: "repeat",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "490da880-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491976,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "device profile",
    clazz: "org.thingsboard.rule.engine.profile.TbDeviceProfileNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Create and clear alarms based on alarm rules defined in device profile. The output relation type is either 'Alarm Created', 'Alarm Updated', 'Alarm Severity Updated' and 'Alarm Cleared' or simply 'Success' if no alarms were affected.",
        description: "Process device messages based on device profile settings",
        inEnabled: true,
        outEnabled: true,
        relationTypes: [
          "Alarm Created",
          "Alarm Updated",
          "Alarm Severity Updated",
          "Alarm Cleared",
          "Success",
          "Failure",
        ],
        customRelations: true,
        ruleChainNode: false,
        defaultConfiguration: {
          persistAlarmRulesState: false,
          fetchAlarmRulesStateOnStart: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbDeviceProfileConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "491d38e0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492078,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "create relation",
    clazz: "org.thingsboard.rule.engine.action.TbCreateRelationNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful when you need to create relations between entities dynamically depending on incoming message payload, message originator type, name, etc.<br><br>Target entity configuration: <ul><li><strong>Device</strong> - use a device with the specified name as the target entity to create a relation with. When selected, rule node allows us to use advanced mode to enable device creation if it doesn't exist. In advanced mode, device profile name should be specified.</li><li><strong>Asset</strong> - use an asset with the specified name as the target entity to create a relation with. When selected, rule node allows us to use advanced mode to enable device creation if it doesn't exist. In advanced mode, asset profile name should be specified.</li><li><strong>Entity View</strong> - use entity view with the specified name as the target entity to create a relation with.</li><li><strong>Tenant</strong> - use current tenant as target entity to create a relation with.</li><li><strong>Customer</strong> - use customer with the specified title as the target entity to create a relation with. When selected, rule node allows us to use advanced mode to enable customer creation if it doesn't exist.</li><li><strong>Dashboard</strong> - use a dashboard with the specified title as the target entity to create a relation with.</li><li><strong>User</strong> - use a user with the specified email as the target entity to create a relation with.</li><li><strong>Edge</strong> - use an edge with the specified name as the target entity to create a relation with.</li></ul>Advanced settings: <ul><li><strong>Remove current relations</strong> - removes current relations with originator of the incoming message based on direction and type. Useful in GPS tracking use cases where relation acts as a temporary indicator of a tracker presence in specific geofence.</li><li><strong>Change originator to target entity</strong> - useful when you need to process submitted message as a message from target entity.</li></ul>Output connections: <code>Success</code> - if the relation already exists or successfully created, otherwise <code>Failure</code>.",
        description:
          "Finds target entity specified in the configuration and creates a relation with the incoming message originator based on the configured direction and type.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          direction: "FROM",
          relationType: "Contains",
          entityType: null,
          entityNamePattern: "",
          entityTypePattern: null,
          createEntityIfNotExists: false,
          changeOriginatorToRelatedEntity: false,
          removeCurrentRelations: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeCreateRelationConfig",
        icon: "add_circle",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4923a180-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492120,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "assign to customer",
    clazz: "org.thingsboard.rule.engine.action.TbAssignToCustomerNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Finds target customer by title and assign message originator entity to this customer. Rule node will create a new customer if it doesn't exist, and 'Create new customer if it doesn't exist' enabled.",
        description: "Assign message originator entity to customer",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          customerNamePattern: "",
          createCustomerIfNotExists: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeAssignToCustomerConfig",
        icon: "add_circle",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49274b00-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492144,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "unassign from customer",
    clazz: "org.thingsboard.rule.engine.action.TbUnassignFromCustomerNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "If the message originator is not assigned to any customer, rule node will do nothing. <br><br>If the incoming message originator is a dashboard, will try to search for the customer by title specified in the configuration. If customer doesn't exist, the exception will be thrown. Otherwise will unassign the dashboard from retrieved customer.<br><br>Other entities can be assigned only to one customer, so specified customer title in the configuration will be ignored if the originator isn't a dashboard.",
        description: "Unassign message originator entity from customer",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          customerNamePattern: "",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeUnAssignToCustomerConfig",
        icon: "remove_circle",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "493813e0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492254,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "synchronization end",
    clazz: "org.thingsboard.rule.engine.transaction.TbSynchronizationEndNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details: "",
        description: 'This Node is now deprecated. Use "Checkpoint" instead.',
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "493f18c0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492300,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "save attributes",
    clazz: "org.thingsboard.rule.engine.telemetry.TbMsgAttributesNode",
    configurationVersion: 2,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Saves entity attributes based on configurable scope parameter. Expects messages with 'POST_ATTRIBUTES_REQUEST' message type. If upsert(update/insert) operation is completed successfully rule node will send the incoming message via <b>Success</b> chain, otherwise, <b>Failure</b> chain is used. Additionally if checkbox <b>Send attributes updated notification</b> is set to true, rule node will put the \"Attributes Updated\" event for <b>SHARED_SCOPE</b> and <b>SERVER_SCOPE</b> attributes updates to the corresponding rule engine queue.Performance checkbox 'Save attributes only if the value changes' will skip attributes overwrites for values with no changes (avoid concurrent writes because this check is not transactional; will not update 'Last updated time' for skipped attributes).",
        description: "Saves attributes data",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          scope: "SERVER_SCOPE",
          notifyDevice: false,
          sendAttributesUpdatedNotification: false,
          updateAttributesOnlyOnValueChange: true,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeAttributesConfig",
        icon: "file_upload",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4943aca0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492330,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "delay (deprecated)",
    clazz: "org.thingsboard.rule.engine.delay.TbMsgDelayNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Delays messages for a configurable period. Please note, this node acknowledges the message from the current queue (message will be removed from queue). Deprecated because the acknowledged message still stays in memory (to be delayed) and this does not guarantee that message will be processed even if the "retry failures and timeouts" processing strategy will be chosen.',
        description: "Delays incoming message (deprecated)",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          periodInSeconds: 60,
          maxPendingMsgs: 1000,
          periodInSecondsPattern: null,
          useMetadataPeriodInSecondsPatterns: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeMsgDelayConfig",
        icon: "pause",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49458160-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492342,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "device state",
    clazz: "org.thingsboard.rule.engine.action.TbDeviceStateNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "If incoming message originator is a device, registers configured event for that device in the Device State Service, which sends appropriate message to the Rule Engine. If metadata <code>ts</code> property is present, it will be used as event timestamp. Otherwise, the message timestamp will be used. If originator entity type is not <code>DEVICE</code> or unexpected error happened during processing, then incoming message is forwarded using <code>Failure</code> chain. If rate of connectivity events for a given originator is too high, then incoming message is forwarded using <code>Rate limited</code> chain. <br>Supported device connectivity events are:<ul><li>Connect event</li><li>Disconnect event</li><li>Activity event</li><li>Inactivity event</li></ul>This node is particularly useful when device isn't using transports to receive data, such as when fetching data from external API or computing new data within the rule chain.",
        description: "Triggers device connectivity events",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure", "Rate limited"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          event: "ACTIVITY_EVENT",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeDeviceStateConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49475620-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 0,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "save time series",
    clazz: "org.thingsboard.rule.engine.telemetry.TbMsgTimeseriesNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Saves time series telemetry data based on configurable TTL parameter. Expects messages with 'POST_TELEMETRY_REQUEST' message type. Timestamp in milliseconds will be taken from metadata.ts, otherwise 'now' message timestamp will be applied. Allows stopping updating values for incoming keys in the latest ts_kv table if 'skipLatestPersistence' is set to true.\n <br/>Enable 'useServerTs' param to use the timestamp of the message processing instead of the timestamp from the message. Useful for all sorts of sequential processing if you merge messages from multiple sources (devices, assets, etc).\n<br/>In the case of sequential processing, the platform guarantees that the messages are processed in the order of their submission to the queue. However, the timestamp of the messages originated by multiple devices/servers may be unsynchronized long before they are pushed to the queue. The DB layer has certain optimizations to ignore the updates of the \"attributes\" and \"latest values\" tables if the new record has a timestamp that is older than the previous record. So, to make sure that all the messages will be processed correctly, one should enable this parameter for sequential message processing scenarios.",
        description: "Saves time series data",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          defaultTTL: 0,
          skipLatestPersistence: false,
          useServerTs: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeTimeseriesConfig",
        icon: "file_upload",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "495008b0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492411,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rpc call reply",
    clazz: "org.thingsboard.rule.engine.rpc.TbSendRPCReplyNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Expects messages with any message type. Will forward message body to the device.",
        description: "Sends reply to RPC call from device",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          serviceIdMetaDataAttribute: "serviceId",
          sessionIdMetaDataAttribute: "sessionId",
          requestIdMetaDataAttribute: "requestId",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeRpcReplyConfig",
        icon: "call_merge",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "495b5350-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492485,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "save to custom table",
    clazz:
      "org.thingsboard.rule.engine.action.TbSaveToCustomCassandraTableNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Administrator should set the custom table name without prefix: <b>cs_tb_</b>. <br>Administrator can configure the mapping between the Message field names and Table columns name.<br><b>Note:</b>If the mapping key is <b>$entity_id</b>, that is identified by the Message Originator, then to the appropriate column name(mapping value) will be write the message originator id.<br><br>If specified message field does not exist or is not a JSON Primitive, the outbound message will be routed via <b>failure</b> chain, otherwise, the message will be routed via <b>success</b> chain.",
        description:
          "Node stores data from incoming Message payload to the Cassandra database into the predefined custom table that should have <b>cs_tb_</b> prefix, to avoid the data insertion to the common TB tables.<br><b>Note:</b> rule node can be used only for Cassandra DB.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          tableName: "",
          fieldsMapping: {
            "": "",
          },
          defaultTtl: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeCustomTableConfig",
        icon: "file_upload",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "495d4f20-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492498,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "gps geofencing events",
    clazz: "org.thingsboard.rule.engine.geo.TbGpsGeofencingActionNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Extracts latitude and longitude parameters from incoming message and returns different events based on configuration parameters. <br><br>If an object with coordinates extracted from incoming message enters the geofence, sends a message with the type <code>Entered</code>. If an object leaves the geofence, sends a message with the type <code>Left</code>. If the presence monitoring strategy <b>"On first message"</b> is selected, sends messages via rule node connection type <code>Inside</code> or <code>Outside</code> only the first time the geofencing and duration conditions are satisfied; otherwise sends messages via rule node connection type <code>Success</code>. If the presence monitoring strategy <b>"On each message"</b> is selected, sends messages via rule node connection type <code>Inside</code> or <code>Outside</code> every time the geofencing condition is satisfied. <br><br>Output connections: <code>Entered</code>, <code>Left</code>, <code>Inside</code>, <code>Outside</code>, <code>Success</code>',
        description: "Produces incoming messages using GPS based geofencing",
        inEnabled: true,
        outEnabled: true,
        relationTypes: [
          "Success",
          "Entered",
          "Left",
          "Inside",
          "Outside",
          "Failure",
        ],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          latitudeKeyName: "latitude",
          longitudeKeyName: "longitude",
          perimeterType: "POLYGON",
          fetchPerimeterInfoFromMessageMetadata: true,
          perimeterKeyName: "ss_perimeter",
          polygonsDefinition: null,
          centerLatitude: null,
          centerLongitude: null,
          range: null,
          rangeUnit: null,
          minInsideDuration: 1,
          minOutsideDuration: 1,
          minInsideDurationTimeUnit: "MINUTES",
          minOutsideDurationTimeUnit: "MINUTES",
          reportPresenceStatusOnEachMessage: true,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeGpsGeofencingConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4960f8a0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492522,
    type: "ACTION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "create alarm",
    clazz: "org.thingsboard.rule.engine.action.TbCreateAlarmNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Details - JS function that creates JSON object based on incoming message. This object will be added into Alarm.details field.\nNode output:\nIf alarm was not created, original message is returned. Otherwise new Message returned with type 'ALARM', Alarm object in 'msg' property and 'metadata' will contains one of those properties 'isNewAlarm/isExistingAlarm'. Message payload can be accessed via <code>msg</code> property. For example <code>'temperature = ' + msg.temperature ;</code>. Message metadata can be accessed via <code>metadata</code> property. For example <code>'name = ' + metadata.customerName;</code>.",
        description: "Create or Update Alarm",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Created", "Updated", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          alarmType: "General Alarm",
          scriptLang: "TBEL",
          alarmDetailsBuildJs:
            "var details = {};\nif (metadata.prevAlarmDetails) {\n    details = JSON.parse(metadata.prevAlarmDetails);\n    //remove prevAlarmDetails from metadata\n    delete metadata.prevAlarmDetails;\n    //now metadata is the same as it comes IN this rule node\n}\n\n\nreturn details;",
          alarmDetailsBuildTbel:
            "var details = {};\nif (metadata.prevAlarmDetails != null) {\n    details = JSON.parse(metadata.prevAlarmDetails);\n    //remove prevAlarmDetails from metadata\n    metadata.remove('prevAlarmDetails');\n    //now metadata is the same as it comes IN this rule node\n}\n\n\nreturn details;",
          severity: "CRITICAL",
          propagate: false,
          propagateToOwner: false,
          propagateToTenant: false,
          useMessageAlarmData: false,
          overwriteAlarmDetails: false,
          dynamicSeverity: false,
          relationTypes: [],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeCreateAlarmConfig",
        icon: "notifications_active",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48d35ea0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491594,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "switch",
    clazz: "org.thingsboard.rule.engine.filter.TbJsSwitchNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Node executes configured TBEL(recommended) or JavaScript function that returns array of strings (connection names). If Array is empty - message not routed to next Node. Message payload can be accessed via <code>msg</code> property. For example <code>msg.temperature < 10;</code><br/>Message metadata can be accessed via <code>metadata</code> property. For example <code>metadata.customerName === 'John';</code><br/>Message type can be accessed via <code>msgType</code> property.<br><br>Output connections: <i>Custom connection(s) defined by switch node</i> or <code>Failure</code>",
        description:
          "Routes incoming message to one OR multiple output connections.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Failure"],
        customRelations: true,
        ruleChainNode: false,
        defaultConfiguration: {
          scriptLang: "TBEL",
          jsScript:
            "function nextRelation(metadata, msg) {\n    return ['one','nine'];\n}\nif(msgType === 'POST_TELEMETRY_REQUEST') {\n    return ['two'];\n}\nreturn nextRelation(metadata, msg);",
          tbelScript:
            "function nextRelation(metadata, msg) {\n    return ['one','nine'];\n}\nif(msgType == 'POST_TELEMETRY_REQUEST') {\n    return ['two'];\n}\nreturn nextRelation(metadata, msg);",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeSwitchConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48d840a0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491626,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "device profile switch",
    clazz: "org.thingsboard.rule.engine.filter.TbDeviceTypeSwitchNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Route incoming messages based on the name of the device profile. The device profile name is case-sensitive<br><br>Output connections: <i>Device profile name</i> or <code>Failure</code>",
        description:
          "Route incoming messages based on the name of the device profile",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["default", "Failure"],
        customRelations: true,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48da1560-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491638,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "entity type switch",
    clazz: "org.thingsboard.rule.engine.filter.TbOriginatorTypeSwitchNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Routes messages to chain according to the entity type ('Device', 'Asset', etc.).<br><br>Output connections: <i>Message originator type</i> or <code>Failure</code>",
        description: "Route incoming messages by Message Originator Type",
        inEnabled: true,
        outEnabled: true,
        relationTypes: [
          "Tenant",
          "Customer",
          "User",
          "Dashboard",
          "Asset",
          "Device",
          "Alarm",
          "Rule chain",
          "Rule node",
          "Entity View",
          "Widgets bundle",
          "Widget type",
          "Tenant profile",
          "Device profile",
          "Asset profile",
          "Api usage state",
          "Resource",
          "Ota package",
          "Edge",
          "Rpc",
          "Queue",
          "Notification target",
          "Notification template",
          "Notification request",
          "Notification",
          "Notification rule",
          "Queue stats",
          "Oauth2 client",
          "Domain",
          "Mobile app",
          "Mobile app bundle",
          "Failure",
        ],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48e86d40-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491732,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "message type filter",
    clazz: "org.thingsboard.rule.engine.filter.TbMsgTypeFilterNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "If incoming message type is expected - send Message via <b>True</b> chain, otherwise <b>False</b> chain is used.<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>",
        description: "Filter incoming messages by Message Type",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          messageTypes: [
            "POST_ATTRIBUTES_REQUEST",
            "POST_TELEMETRY_REQUEST",
            "TO_SERVER_RPC_REQUEST",
          ],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeMessageTypeConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48f5b3b0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491819,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "asset profile switch",
    clazz: "org.thingsboard.rule.engine.filter.TbAssetTypeSwitchNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Route incoming messages based on the name of the asset profile. The asset profile name is case-sensitive.<br><br>Output connections: <i>Asset profile name</i> or <code>Failure</code>",
        description:
          "Route incoming messages based on the name of the asset profile",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["default", "Failure"],
        customRelations: true,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48f7fda0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491834,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "script",
    clazz: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Evaluates boolean function using incoming message. The function may be written using TBEL or plain JavaScript. Script function should return boolean value and accepts three parameters: <br/>Message payload can be accessed via <code>msg</code> property. For example <code>msg.temperature < 10;</code><br/>Message metadata can be accessed via <code>metadata</code> property. For example <code>metadata.customerName === 'John';</code><br/>Message type can be accessed via <code>msgType</code> property.<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>",
        description: "Filter incoming messages using TBEL or JS script",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          scriptLang: "TBEL",
          jsScript: "return msg.temperature > 20;",
          tbelScript: "return msg.temperature > 20;",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeScriptConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4904f5f0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491919,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "message type switch",
    clazz: "org.thingsboard.rule.engine.filter.TbMsgTypeSwitchNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Sends messages with message types <b>"Post attributes", "Post telemetry", "RPC Request"</b> etc. via corresponding chain, otherwise <b>Other</b> chain is used.<br><br>Output connections: <i>Message type connection</i>, <code>Other</code> - if message type is custom or <code>Failure</code>',
        description: "Route incoming messages by Message Type",
        inEnabled: true,
        outEnabled: true,
        relationTypes: [
          "Post attributes",
          "Post telemetry",
          "RPC Request from Device",
          "Activity Event",
          "Inactivity Event",
          "Connect Event",
          "Disconnect Event",
          "Entity Created",
          "Entity Updated",
          "Entity Deleted",
          "Entity Assigned",
          "Entity Unassigned",
          "Attributes Updated",
          "Attributes Deleted",
          "Alarm Acknowledged",
          "Alarm Cleared",
          "Alarm Assigned",
          "Alarm Unassigned",
          "Comment Created",
          "Comment Updated",
          "RPC Request to Device",
          "Entity Assigned From Tenant",
          "Entity Assigned To Tenant",
          "Timeseries Updated",
          "Timeseries Deleted",
          "RPC Queued",
          "RPC Sent",
          "RPC Delivered",
          "RPC Successful",
          "RPC Timeout",
          "RPC Expired",
          "RPC Failed",
          "RPC Deleted",
          "Relation Added or Updated",
          "Relation Deleted",
          "All Relations Deleted",
          "REST API request",
          "Other",
          "Failure",
        ],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "490b85a0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491962,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "check relation presence",
    clazz: "org.thingsboard.rule.engine.filter.TbCheckRelationNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "If 'check relation to specific entity' is selected, you should specify a related entity. Otherwise, the rule node checks the presence of a relation to any entity. In both cases, relation lookup is based on configured direction and type.<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>",
        description:
          "Checks the presence of the relation between the originator of the message and other entities.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          direction: "FROM",
          entityId: null,
          entityType: null,
          relationType: "Contains",
          checkForSingleEntity: true,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeCheckRelationConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "490fcb60-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491990,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "entity type filter",
    clazz: "org.thingsboard.rule.engine.filter.TbOriginatorTypeFilterNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Checks that the entity type of the incoming message originator matches one of the values specified in the filter.<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>",
        description:
          "Filter incoming messages by the type of message originator entity",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          originatorTypes: ["DEVICE"],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeOriginatorTypeConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "491ff800-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492096,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "gps geofencing filter",
    clazz: "org.thingsboard.rule.engine.geo.TbGpsGeofencingFilterNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'Extracts latitude and longitude parameters from the incoming message and checks them according to configured perimeter. </br>Configuration:</br></br><ul><li>Latitude key name - name of the message field that contains location latitude;</li><li>Longitude key name - name of the message field that contains location longitude;</li><li>Perimeter type - Polygon or Circle;</li><li>Fetch perimeter from message metadata - checkbox to load perimeter from message metadata;    Enable if your perimeter is specific to device/asset and you store it as device/asset attribute;</li><li>Perimeter key name - name of the metadata key that stores perimeter information;</li><li>For Polygon perimeter type: <ul>    <li>Polygon definition - string that contains array of coordinates in the following format: [[lat1, lon1],[lat2, lon2],[lat3, lon3], ... , [latN, lonN]]</li></ul></li><li>For Circle perimeter type: <ul>   <li>Center latitude - latitude of the circle perimeter center;</li>   <li>Center longitude - longitude of the circle perimeter center;</li>   <li>Range - value of the circle perimeter range, double-precision floating-point value;</li>   <li>Range units - one of: Meter, Kilometer, Foot, Mile, Nautical Mile;</li></ul></li></ul></br>Rule node will use default metadata key names, if the "Fetch perimeter from message metadata" is enabled and "Perimeter key name" is not configured. Default metadata key names for polygon perimeter type is "perimeter". Default metadata key names for circle perimeter are: "centerLatitude", "centerLongitude", "range", "rangeUnit".</br></br>Structure of the circle perimeter definition (stored in server-side attribute, for example):</br></br>{"latitude":  48.198618758582384, "longitude": 24.65322245153503, "radius":  100.0, "radiusUnit": "METER" }</br></br>Available radius units: METER, KILOMETER, FOOT, MILE, NAUTICAL_MILE;<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>',
        description: "Filter incoming messages by GPS based geofencing",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          latitudeKeyName: "latitude",
          longitudeKeyName: "longitude",
          perimeterType: "POLYGON",
          fetchPerimeterInfoFromMessageMetadata: true,
          perimeterKeyName: "ss_perimeter",
          polygonsDefinition: null,
          centerLatitude: null,
          centerLongitude: null,
          range: null,
          rangeUnit: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeGpsGeofencingConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "494951f0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492367,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "alarm status filter",
    clazz: "org.thingsboard.rule.engine.filter.TbCheckAlarmStatusNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Checks the alarm status to match one of the specified statuses.<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>.",
        description: "Checks alarm status.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          alarmStatusList: ["ACTIVE_ACK", "ACTIVE_UNACK"],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeCheckAlarmStatusConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4957d0e0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492462,
    type: "FILTER",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "check fields presence",
    clazz: "org.thingsboard.rule.engine.filter.TbCheckMessageNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "By default, the rule node checks that all specified fields are present. Uncheck the 'Check that all selected fields are present' if the presence of at least one field is sufficient.<br><br>Output connections: <code>True</code>, <code>False</code>, <code>Failure</code>",
        description:
          "Checks the presence of the specified fields in the message and/or metadata.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["True", "False", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          messageNames: [],
          metadataNames: [],
          checkAllKeys: true,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbFilterNodeCheckMessageConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48dcd480-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491656,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "originator telemetry",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetTelemetryNode",
    configurationVersion: 2,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful when you need to get telemetry data set from the message originator for a specific time range instead of fetching just the latest telemetry or if you need to get the closest telemetry to the fetch interval start or end. Also, this node can be used for telemetry aggregation within configured fetch interval.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds message originator telemetry for selected time range into message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          startInterval: 2,
          endInterval: 1,
          startIntervalPattern: "",
          endIntervalPattern: "",
          useMetadataIntervalPatterns: false,
          startIntervalTimeUnit: "MINUTES",
          endIntervalTimeUnit: "MINUTES",
          fetchMode: "FIRST",
          orderBy: "ASC",
          aggregation: "NONE",
          limit: 1000,
          latestTsKeyNames: [],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeGetTelemetryFromDatabase",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48e64a60-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491718,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "originator attributes",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetAttributesNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful when you need to retrieve some attributes or the latest telemetry readings from the message originator that are not included in the incoming message to use them for further message processing. For example to filter messages based on the threshold value stored in the attributes.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds attributes and/or latest timeseries data for the message originator to the message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
          clientAttributeNames: [],
          sharedAttributeNames: [],
          serverAttributeNames: [],
          latestTsKeyNames: [],
          tellFailureIfAbsent: true,
          getLatestValueWithTs: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeOriginatorAttributesConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48ed7650-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491765,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "related entity data",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetRelatedAttributeNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Related entity lookup based on the configured relation query. If multiple related entities are found, only first entity is used for message enrichment, other entities are discarded. Useful when you need to retrieve data from an entity that has a relation to the message originator and use them for further message processing.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds originators related entity attributes or latest telemetry or fields into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
          dataMapping: {
            serialNumber: "sn",
          },
          dataToFetch: "ATTRIBUTES",
          relationsQuery: {
            direction: "FROM",
            maxLevel: 1,
            filters: [
              {
                relationType: "Contains",
                entityTypes: [],
                negate: false,
              },
            ],
            fetchLastLevelOnly: false,
          },
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeRelatedAttributesConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49073fe0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491934,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "fetch device credentials",
    clazz: "org.thingsboard.rule.engine.metadata.TbFetchDeviceCredentialsNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "if message originator type is Device and device credentials was successfully fetched, rule node enriches message or message metadata with <i>credentialsType</i> and <i>credentials</i> properties. Useful when you need to fetch device credentials and use them for further message processing. For example, use device credentials to interact with external systems.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds device credentials to the message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeFetchDeviceCredentialsConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "491856e0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492046,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "calculate delta",
    clazz: "org.thingsboard.rule.engine.metadata.CalculateDeltaNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful for metering use cases, when you need to calculate consumption based on pulse counter reading.<br><br>Output connections: <code>Success</code>, <code>Other</code> or <code>Failure</code>.",
        description:
          "Calculates delta and amount of time passed between previous timeseries key reading and current value for this key from the incoming message",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure", "Other"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          inputValueKey: "pulseCounter",
          outputValueKey: "delta",
          useCache: true,
          addPeriodBetweenMsgs: false,
          periodValueKey: "periodInMs",
          round: null,
          tellFailureIfDeltaIsNegative: true,
          excludeZeroDeltas: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeCalculateDeltaConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "491aeef0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492063,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "related device attributes",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetDeviceAttrNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Related device lookup based on the configured relation query. If multiple related devices are found, only first device is used for message enrichment, other entities are discarded. Useful when you need to retrieve attributes and/or latest telemetry values from device that has a relation to the message originator and use them for further message processing.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Add originators related device attributes and/or latest telemetry values into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
          clientAttributeNames: [],
          sharedAttributeNames: [],
          serverAttributeNames: [],
          latestTsKeyNames: [],
          tellFailureIfAbsent: true,
          getLatestValueWithTs: false,
          deviceRelationsQuery: {
            direction: "FROM",
            maxLevel: 1,
            relationType: "Contains",
            deviceTypes: ["default"],
            fetchLastLevelOnly: false,
          },
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeDeviceAttributesConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "492cc940-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492180,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "tenant details",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetTenantDetailsNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful when we need to retrieve contact information from your tenant such as email, phone, address, etc., for notifications via email, SMS, and other notification providers.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds message originator tenant details into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "DATA",
          detailsList: [],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeEntityDetailsConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49540050-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492437,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "customer attributes",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetCustomerAttributeNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful in multi-customer solutions where each customer has a different configuration or threshold set that is stored as customer attributes or telemetry data and used for dynamic message filtering, transformation, or actions such as alarm creation if the threshold is exceeded.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds message originator customer attributes or latest telemetry into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
          dataMapping: {
            alarmThreshold: "threshold",
          },
          dataToFetch: "ATTRIBUTES",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeCustomerAttributesConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4955fc20-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492450,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "originator fields",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetOriginatorFieldsNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Fetches fields values specified in the mapping. If specified field is not part of originator fields it will be ignored. Useful when you need to retrieve originator fields and use them for further message processing.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds message originator fields values into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
          dataMapping: {
            name: "originatorName",
            type: "originatorType",
          },
          ignoreNullStrings: false,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeOriginatorFieldsConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49597e90-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492473,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "customer details",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetCustomerDetailsNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful in multi-customer solutions where we need dynamically use customer contact information such as email, phone, address, etc., for notifications via email, SMS, and other notification providers.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds message originator customer details into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "DATA",
          detailsList: [],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeEntityDetailsConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "495efcd0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492509,
    type: "BILL_GENERATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "tenant attributes",
    clazz: "org.thingsboard.rule.engine.metadata.TbGetTenantAttributeNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Useful when you need to retrieve some common configuration or threshold set that is stored as tenant attributes or telemetry data and use it for further message processing.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Adds message originator tenant attributes or latest telemetry into message or message metadata",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fetchTo: "METADATA",
          dataMapping: {
            alarmThreshold: "threshold",
          },
          dataToFetch: "ATTRIBUTES",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbEnrichmentNodeTenantAttributesConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "488b5920-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491122,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "delete key-value pairs",
    clazz: "org.thingsboard.rule.engine.transform.TbDeleteKeysNode",
    configurationVersion: 2,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Deletes key-value pairs from the message or message metadata according to the configured keys and/or regular expressions.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Deletes key-value pairs from message or message metadata.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          deleteFrom: "DATA",
          keys: [],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeDeleteKeysConfig",
        icon: "remove_circle",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48cc0ba0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491546,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "deduplication",
    clazz: "org.thingsboard.rule.engine.deduplication.TbMsgDeduplicationNode",
    configurationVersion: 1,
    actions: null,
    hasQueueName: true,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Deduplication strategies: <ul><li><strong>FIRST</strong> - return first message that arrived during deduplication period.</li><li><strong>LAST</strong> - return last message that arrived during deduplication period.</li><li><strong>ALL</strong> - return all messages as a single JSON array message. Where each element represents object with <strong><i>msg</i></strong> and <strong><i>metadata</i></strong> inner properties.</li></ul>",
        description:
          "Deduplicate messages within the same originator entity for a configurable period based on a specified deduplication strategy.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          interval: 60,
          strategy: "FIRST",
          outMsgType: null,
          maxPendingMsgs: 100,
          maxRetries: 3,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbActionNodeMsgDeduplicationConfig",
        icon: "content_copy",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48ce5590-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491561,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "json path",
    clazz: "org.thingsboard.rule.engine.transform.TbJsonPathNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "JSONPath expression specifies a path to an element or a set of elements in a JSON structure.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Transforms incoming message body using JSONPath expression.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          jsonPath: "$",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeJsonPathConfig",
        icon: "functions",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "48e1dd90-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491689,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "rename keys",
    clazz: "org.thingsboard.rule.engine.transform.TbRenameKeysNode",
    configurationVersion: 2,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Renames keys in the message or message metadata according to the provided mapping. If key to rename doesn't exist in the specified source (message or message metadata) it will be ignored.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description: "Renames message or message metadata keys.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          renameIn: "DATA",
          renameKeysMapping: {
            temperatureCelsius: "temperature",
          },
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeRenameKeysConfig",
        icon: "find_replace",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4902d310-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165491905,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "script",
    clazz: "org.thingsboard.rule.engine.transform.TbTransformMsgNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          'JavaScript function receive 3 input parameters <br/> <code>msg</code> - is a message payload.<br/><code>metadata</code> - is a message metadata.<br/><code>msgType</code> - is a message type.<br/>Should return the following structure:<br/><code>{ msg: <i style="color: #666;">new payload</i>,<br/>&nbsp&nbsp&nbspmetadata: <i style="color: #666;">new metadata</i>,<br/>&nbsp&nbsp&nbspmsgType: <i style="color: #666;">new msgType</i> }</code><br/>All fields in resulting object are optional and will be taken from original message if not specified.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.',
        description:
          "Change Message payload, Metadata or Message type using JavaScript",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          scriptLang: "TBEL",
          jsScript: "return {msg: msg, metadata: metadata, msgType: msgType};",
          tbelScript:
            "return {msg: msg, metadata: metadata, msgType: msgType};",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeScriptConfig",
        icon: "",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4913ea10-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492017,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "change originator",
    clazz: "org.thingsboard.rule.engine.transform.TbChangeOriginatorNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Configuration: <ul><li><strong>Customer</strong> - use customer of incoming message originator as new originator. Only for assigned to customer originators with one of the following type: 'User', 'Asset', 'Device'.</li><li><strong>Tenant</strong> - use current tenant as new originator.</li><li><strong>Related Entity</strong> - use related entity as new originator. Lookup based on configured relation query. If multiple related entities are found, only first entity is used as new originator, other entities are discarded.</li><li><strong>Alarm Originator</strong> - use alarm originator as new originator. Only if incoming message originator is alarm entity.</li><li><strong>Entity by name pattern</strong> - specify entity type and name pattern of new originator. Following entity types are supported: 'Device', 'Asset', 'Entity View', 'Edge' or 'User'.</li></ul>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Change message originator to Tenant/Customer/Related Entity/Alarm Originator/Entity by name pattern.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          originatorSource: "CUSTOMER",
          relationsQuery: {
            direction: "FROM",
            maxLevel: 1,
            filters: [
              {
                relationType: "Contains",
                entityTypes: [],
                negate: false,
              },
            ],
            fetchLastLevelOnly: false,
          },
          entityType: null,
          entityNamePattern: null,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeChangeOriginatorConfig",
        icon: "find_replace",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "4921a5b0-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492107,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "split array msg",
    clazz: "org.thingsboard.rule.engine.transform.TbSplitArrayMsgNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Splits an array message into individual elements, with each element sent as a separate message. All outbound messages will have the same type and metadata as the original array message.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description: "Split array message into several messages",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          version: 0,
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbNodeEmptyConfig",
        icon: "content_copy",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "49257640-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492132,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "to email",
    clazz: "org.thingsboard.rule.engine.mail.TbMsgToEmailNode",
    configurationVersion: 0,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Transforms message to email message. If transformation completed successfully output message type will be set to <code>SEND_EMAIL</code>.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description: "Transforms message to email message",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          fromTemplate: "info@testmail.org",
          toTemplate: "${userEmail}",
          ccTemplate: null,
          bccTemplate: null,
          subjectTemplate: "Device ${deviceType} temperature high",
          bodyTemplate:
            "Device ${deviceName} has high temperature $[temperature]",
          isHtmlTemplate: null,
          mailBodyType: "false",
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeToEmailConfig",
        icon: "email",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
  {
    id: {
      id: "492ec510-e770-11ef-a60f-836bea56f698",
    },
    createdTime: 1739165492193,
    type: "TRANSFORMATION",
    scope: "TENANT",
    clusteringMode: "ENABLED",
    name: "copy key-value pairs",
    clazz: "org.thingsboard.rule.engine.transform.TbCopyKeysNode",
    configurationVersion: 2,
    actions: null,
    hasQueueName: false,
    configurationDescriptor: {
      nodeDefinition: {
        details:
          "Copies key-value pairs from the message to message metadata, or vice-versa, according to the configured direction and keys. Regular expressions can be used to define which keys-value pairs to copy. Any configured key not found in the source will be ignored.<br><br>Output connections: <code>Success</code>, <code>Failure</code>.",
        description:
          "Copies key-value pairs from message to message metadata or vice-versa.",
        inEnabled: true,
        outEnabled: true,
        relationTypes: ["Success", "Failure"],
        customRelations: false,
        ruleChainNode: false,
        defaultConfiguration: {
          copyFrom: "DATA",
          keys: [],
        },
        uiResources: ["static/rulenode/rulenode-core-config.js"],
        configDirective: "tbTransformationNodeCopyKeysConfig",
        icon: "content_copy",
        iconUrl: "",
        docUrl: "",
      },
    },
  },
];

const VeeRuleMetaDataDummyData = {
  ruleChainId: {
    entityType: "RULE_CHAIN",
    id: "a3358fd0-03d1-11f0-9f1a-2db71be85a80",
  },
  version: 36,
  firstNodeIndex: 0,
  nodes: [
    {
      id: {
        entityType: "RULE_NODE",
        id: "ea0b4260-03d1-11f0-9f1a-2db71be85a80",
      },
      createdTime: 1742286055814,
      ruleChainId: {
        entityType: "RULE_CHAIN",
        id: "a3358fd0-03d1-11f0-9f1a-2db71be85a80",
      },
      type: "org.thingsboard.rule.engine.filter.TbJsFilterNode",
      name: "kWh threshold validation",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1742288782387,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      externalId: null,
      configuration: {
        scriptLang: "TBEL",
        jsScript: "return msg.temperature > 20;",
        tbelScript:
          "// Check if msg and timeseries data exist\nif (msg != null && msg.timeseries != null && msg.timeseries.length > 0) {\n    // Extract the IP_KWH value from the first timeseries entry\n    var IP_KWH = msg['timeseries'][0]['values']['IP_KWH'];\n\n    // Check if IP_KWH exists and is within the acceptable range\n    if (IP_KWH != null && IP_KWH >= 0 && IP_KWH <= 500) {\n        return true;  // Valid value\n    } else {\n        return false;  // Invalid value or out of range\n    }\n} else {\n    return false;  // Invalid message structure or missing timeseries data\n}\n",
      },
      additionalInfo: {
        description: "",
        layoutX: 331,
        layoutY: 181,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "ea0b6970-03d1-11f0-9f1a-2db71be85a80",
      },
      createdTime: 1742286055815,
      ruleChainId: {
        entityType: "RULE_CHAIN",
        id: "a3358fd0-03d1-11f0-9f1a-2db71be85a80",
      },
      type: "org.thingsboard.rule.engine.telemetry.TbMsgTimeseriesNode",
      name: "Save telemetry",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1742288909571,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      externalId: null,
      configuration: {
        defaultTTL: 0,
        skipLatestPersistence: false,
        useServerTs: false,
      },
      additionalInfo: {
        description: "",
        layoutX: 755,
        layoutY: 132,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "ea0b9080-03d1-11f0-9f1a-2db71be85a80",
      },
      createdTime: 1742286055816,
      ruleChainId: {
        entityType: "RULE_CHAIN",
        id: "a3358fd0-03d1-11f0-9f1a-2db71be85a80",
      },
      type: "org.thingsboard.rule.engine.action.TbLogNode",
      name: "Log",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1742288782387,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 0,
      externalId: null,
      configuration: {
        scriptLang: "TBEL",
        jsScript:
          "return '\\nIncoming message:\\n' + JSON.stringify(msg) + '\\nIncoming metadata:\\n' + JSON.stringify(metadata);",
        tbelScript:
          "return '\\n=======================================================\\n' + '\\nREAD FAILED VALIDATION: IP_KWH must be between 0 and 500:' + '\\n=======================================================\\n' + '\\nIncoming message:\\n' + JSON.stringify(msg) + '\\nIncoming metadata:\\n' + JSON.stringify(metadata);",
      },
      additionalInfo: {
        description: "",
        layoutX: 772,
        layoutY: 288,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "42c89dc0-2584-11f0-b562-219ea63c0dad",
      },
      createdTime: 1745991043484,
      ruleChainId: {
        entityType: "RULE_CHAIN",
        id: "a3358fd0-03d1-11f0-9f1a-2db71be85a80",
      },
      type: "org.thingsboard.rule.engine.rest.TbRestApiCallNode",
      name: "An API call",
      debugSettings: {
        failuresEnabled: true,
        allEnabled: false,
        allEnabledUntil: 1742285679257,
      },
      singletonMode: false,
      queueName: "",
      configurationVersion: 3,
      externalId: null,
      configuration: {
        restEndpointUrlPattern: "http://localhost/apis",
        requestMethod: "POST",
        headers: {
          "Content-Type": "application/json",
          Auth: "xyz",
        },
        useSimpleClientHttpFactory: false,
        readTimeoutMs: 0,
        maxParallelRequestsCount: "10",
        parseToPlainText: true,
        enableProxy: true,
        useSystemProxyProperties: false,
        proxyHost: "",
        proxyPort: 0,
        proxyUser: "",
        proxyPassword: "",
        proxyScheme: "",
        credentials: {
          type: "anonymous",
        },
        ignoreRequestBody: true,
        maxInMemoryBufferSizeInKb: 256,
      },
      additionalInfo: {
        description: "",
        layoutX: 920,
        layoutY: 377,
      },
    },
  ],
  connections: [
    {
      fromIndex: 0,
      toIndex: 1,
      type: "True",
    },
    {
      fromIndex: 0,
      toIndex: 2,
      type: "False",
    },
    {
      fromIndex: 2,
      toIndex: 3,
      type: "Success",
    },
  ],
  ruleChainConnections: null,
};

export const BuildModuleRule1MetaDataDummyData2 = {
  ruleChainId: {
    entityType: "RULE_CHAIN",
    id: "bfe18d20-e773-11ef-a6a1-c5603cdacbcd",
  },
  version: 14,
  firstNodeIndex: 0,
  nodes: [
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11c1a90-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.filter.TbJsBillValidationNode",
      name: "Validate Bill Due Date",
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          '// Step 1: Check bill object and due date validity\nif (msg && msg.billId && msg.dueDate && msg.status === "APPROVED") {\n    var due = new Date(msg.dueDate);\n    var today = new Date();\n    var diffDays = Math.ceil((due - today) / (1000 * 60 * 60 * 24));\n    msg.daysUntilDue = diffDays;\n    return true;\n} else {\n    return false;\n}',
      },
      additionalInfo: {
        description:
          "Validates if bill has a valid due date and approved status",
        layoutX: 197.16061185468453,
        layoutY: 181.41969407265773,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11c3aa0-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.action.TbInvalidBillLogNode",
      name: "Invalid Bill Log",
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          'return "❌ Skipping reminder: Invalid bill or missing due date -> " + JSON.stringify(msg);',
      },
      additionalInfo: {
        description: "Logs invalid bills missing due date or approval",
        layoutX: 265.368068833652,
        layoutY: 314.5076481835564,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11c6ab0-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.transform.TbReminderStageNode",
      name: "Determine Reminder Stage",
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          '// Step 2: Determine reminder stage based on days until due\nif (msg.daysUntilDue > 5) {\n    msg.reminderStage = "INITIAL";\n} else if (msg.daysUntilDue <= 5 && msg.daysUntilDue >= 1) {\n    msg.reminderStage = "FINAL";\n} else if (msg.daysUntilDue < 0) {\n    msg.reminderStage = "OVERDUE";\n}\nreturn msg;',
      },
      additionalInfo: {
        description: "Classifies reminder type (Initial, Final, or Overdue)",
        layoutX: 441.66826003824093,
        layoutY: 185.67877629063094,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11c9ac0-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.billing.rule.engine.notification.TbSendInitialReminderNode",
      name: "Send Initial Reminder",
      configuration: {
        restEndpointUrlPattern: "http://localhost:8080/api/notify/reminder",
        requestMethod: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: {
          type: "anonymous",
        },
      },
      additionalInfo: {
        description: "Sends the first reminder before 5+ days of due date",
        layoutX: 830.7982791586999,
        layoutY: 95.67877629063096,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11ccad0-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.billing.rule.engine.notification.TbSendFinalReminderNode",
      name: "Send Final Reminder",
      configuration: {
        restEndpointUrlPattern: "http://localhost:8080/api/notify/final",
        requestMethod: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: {
          type: "anonymous",
        },
      },
      additionalInfo: {
        description: "Sends a final reminder 1–5 days before the due date",
        layoutX: 826.5391969407266,
        layoutY: 187.1606118546845,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11cfae0-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.billing.rule.engine.notification.TbSendOverdueNoticeNode",
      name: "Apply Late Fee",
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          '// Step 3: Apply penalty for overdue bills\nif (msg.reminderStage === "OVERDUE" && msg.billAmount) {\n    var penalty = (msg.billAmount * 0.02).toFixed(2);\n    msg.lateFee = penalty;\n    msg.status = "OVERDUE";\n    msg.totalDue = (parseFloat(msg.billAmount) + parseFloat(penalty)).toFixed(2);\n    return msg;\n} else {\n    return msg;\n}',
      },
      additionalInfo: {
        description: "Adds 2% penalty for overdue bills and updates total",
        layoutX: 705.8652007648184,
        layoutY: 300.0621414913958,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11d1af0-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.thingsboard.rule.engine.rest.TbSendOverdueNoticeNode",
      name: "Send Overdue Notice",
      configuration: {
        restEndpointUrlPattern: "http://localhost:8080/api/notify/overdue",
        requestMethod: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: {
          type: "anonymous",
        },
      },
      additionalInfo: {
        description: "Notifies customer about overdue status and added penalty",
        layoutX: 945.9273422562139,
        layoutY: 302.90152963671136,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11d3b00-39a5-11f0-93a4-7fc3c203433",
      },
      type: "org.thingsboard.rule.engine.action.TbReminderResultLogNode",
      name: "Log Reminder Status",
      configuration: {
        scriptLang: "TBEL",
        tbelScript:
          'return "📅 Reminder sent successfully -> " + JSON.stringify(msg);',
      },
      additionalInfo: {
        description: "Logs each reminder and status update",
        layoutX: 1180,
        layoutY: 190,
      },
    },
    {
      id: {
        entityType: "RULE_NODE",
        id: "b11d6b10-39a5-11f0-93a4-7fc3c20f1a11",
      },
      type: "org.billing.rule.engine.reporting.TbBillingHistoryExportNode",
      name: "Send Reminder Report",
      configuration: {
        restEndpointUrlPattern: "http://localhost:8080/api/report/reminder",
        requestMethod: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: {
          type: "anonymous",
        },
      },
      additionalInfo: {
        description: "Sends reminder summary to reporting service",
        layoutX: 1448.1453154875717,
        layoutY: 190,
      },
    },
  ],
  connections: [
    {
      fromIndex: 0,
      toIndex: 2,
      type: "True",
    },
    {
      fromIndex: 0,
      toIndex: 1,
      type: "False",
    },
    {
      fromIndex: 2,
      toIndex: 3,
      type: "Initial",
    },
    {
      fromIndex: 2,
      toIndex: 4,
      type: "Final",
    },
    {
      fromIndex: 2,
      toIndex: 5,
      type: "Overdue",
    },
    {
      fromIndex: 5,
      toIndex: 6,
      type: "Success",
    },
    {
      fromIndex: 3,
      toIndex: 7,
      type: "Success",
    },
    {
      fromIndex: 4,
      toIndex: 7,
      type: "Success",
    },
    {
      fromIndex: 6,
      toIndex: 7,
      type: "Success",
    },
    {
      fromIndex: 7,
      toIndex: 8,
      type: "Success",
    },
  ],
};
